import * as React from 'react';
import styled, { css, ThemeContext } from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus';
import { faMinus } from '@fortawesome/free-solid-svg-icons/faMinus';
import { motion, AnimatePresence } from 'framer-motion';
import { rgba, darken } from 'polished';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons/faAngleLeft';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons/faAngleRight';
import { faArrowDown } from '@fortawesome/free-solid-svg-icons/faArrowDown';
import { faArrowUp } from '@fortawesome/free-solid-svg-icons/faArrowUp';
import { faBan } from '@fortawesome/free-solid-svg-icons/faBan';
import { faBars } from '@fortawesome/free-solid-svg-icons/faBars';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons/faCaretDown';
import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons/faCheckCircle';
import { faCheckSquare } from '@fortawesome/free-solid-svg-icons/faCheckSquare';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons/faChevronUp';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons/faChevronDown';
import { faChevronCircleDown } from '@fortawesome/free-solid-svg-icons/faChevronCircleDown';
import { faChevronCircleUp } from '@fortawesome/free-solid-svg-icons/faChevronCircleUp';
import { faClipboard } from '@fortawesome/free-solid-svg-icons/faClipboard';
import { faClipboardList } from '@fortawesome/free-solid-svg-icons/faClipboardList';
import { faClock } from '@fortawesome/free-solid-svg-icons/faClock';
import { faClone } from '@fortawesome/free-solid-svg-icons/faClone';
import { faCog } from '@fortawesome/free-solid-svg-icons/faCog';
import { faEdit } from '@fortawesome/free-solid-svg-icons/faEdit';
import { faExclamation } from '@fortawesome/free-solid-svg-icons/faExclamation';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons/faExclamationCircle';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons/faExclamationTriangle';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons/faExternalLinkAlt';
import { faEyeSlash } from '@fortawesome/free-solid-svg-icons/faEyeSlash';
import { faFile } from '@fortawesome/free-solid-svg-icons/faFile';
import { faFileAlt } from '@fortawesome/free-solid-svg-icons/faFileAlt';
import { faFolder } from '@fortawesome/free-solid-svg-icons/faFolder';
import { faFolderOpen } from '@fortawesome/free-solid-svg-icons/faFolderOpen';
import { faFolder as faFolder$1 } from '@fortawesome/free-regular-svg-icons/faFolder';
import { faGlobeAmericas } from '@fortawesome/free-solid-svg-icons/faGlobeAmericas';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons/faInfoCircle';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons/faCircleNotch';
import { faLock } from '@fortawesome/free-solid-svg-icons/faLock';
import { faPaperclip } from '@fortawesome/free-solid-svg-icons/faPaperclip';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons/faPencilAlt';
import { faPowerOff } from '@fortawesome/free-solid-svg-icons/faPowerOff';
import { faSearch } from '@fortawesome/free-solid-svg-icons/faSearch';
import { faShareSquare } from '@fortawesome/free-solid-svg-icons/faShareSquare';
import { faSortDown } from '@fortawesome/free-solid-svg-icons/faSortDown';
import { faSortUp } from '@fortawesome/free-solid-svg-icons/faSortUp';
import { faStickyNote } from '@fortawesome/free-solid-svg-icons/faStickyNote';
import { faSyncAlt } from '@fortawesome/free-solid-svg-icons/faSyncAlt';
import { faTable } from '@fortawesome/free-solid-svg-icons/faTable';
import { faTicketAlt } from '@fortawesome/free-solid-svg-icons/faTicketAlt';
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons/faTimesCircle';
import { faTrashAlt } from '@fortawesome/free-regular-svg-icons/faTrashAlt';
import { faUndo } from '@fortawesome/free-solid-svg-icons/faUndo';
import { faWindowClose } from '@fortawesome/free-solid-svg-icons/faWindowClose';
import { faWindowMaximize } from '@fortawesome/free-solid-svg-icons/faWindowMaximize';
import { useDropzone } from 'react-dropzone';
import * as ReactDOM from 'react-dom';
import ReactSelect from 'react-select';

const Plus = (props) => {
    return React.createElement(FontAwesomeIcon, Object.assign({ icon: faPlus }, props));
};

const Minus = (props) => {
    return React.createElement(FontAwesomeIcon, Object.assign({ icon: faMinus }, props));
};

const HeaderContent = styled.div ``;
const HeaderIconContainer = styled.div `
  display: flex;
  align-items: center;

  justify-self: end;
`;
const StyledHeader = styled.div `
  ${({ customProps, theme }) => css `
    display: grid;
    grid-template-columns: auto 0.2fr;
    align-items: center;

    background: ${theme.collapseHeaderBackground};
    border: ${theme.collapseBorder};
    border-color: ${theme.collapseBorderColor};
    border-radius: ${theme.collapseBorderRadius};
    color: ${theme.collapseHeaderColor};

    padding: ${theme.collapseHeaderPadding};
    height: ${theme.collapseHeaderHeight};

    box-sizing: border-box;
    user-select: none;
    cursor: pointer;

    transition: all ${theme.animationTimeVeryFast}s;

    &:hover {
      background: ${theme.collapseHeaderHoverBackground};
      border: 1px solid transparent;
      color: ${theme.collapseHeaderHoverColor};
    }

    ${customProps.expanded &&
    css `
      border-bottom-right-radius: 0;
      border-bottom-left-radius: 0;
    `};
  `};
`;
const HeaderIcon = ({ icon, expanded, theme, }) => {
    if (icon) {
        return React.createElement(HeaderIconContainer, null, icon);
    }
    else if (expanded) {
        return (React.createElement(HeaderIconContainer, null,
            React.createElement(Minus, { style: {
                    height: theme.collapseIconSize,
                    width: theme.collapseIconSize,
                } })));
    }
    return (React.createElement(HeaderIconContainer, null,
        React.createElement(Plus, { style: {
                height: theme.collapseIconSize,
                width: theme.collapseIconSize,
            } })));
};
const Header$3 = ({ disabled, icon, children, onClick, expanded, theme, }) => (React.createElement(StyledHeader, { className: "rtk-collapse-header", theme: theme, onClick: onClick, customProps: {
        expanded,
    } },
    React.createElement(HeaderContent, null, children),
    !disabled && React.createElement(HeaderIcon, { icon: icon, expanded: expanded, theme: theme })));
Header$3.displayName = 'CollapseHeader';

const ContentContainer$1 = ({ animate, children, destroyOnClose, theme, }) => {
    const variants = {
        closed: {
            height: 0,
        },
        open: {
            height: 'auto',
        },
    };
    const content = (React.createElement(motion.div, { key: "content", style: {
            overflow: 'hidden',
        }, initial: "closed", exit: "closed", animate: animate, variants: variants, transition: { duration: theme.animationTimeVeryFast, type: 'tween' } }, children));
    return (React.createElement(AnimatePresence, { initial: false }, destroyOnClose ? animate === 'open' && content : content));
};
const StyledContentBody = styled.div `
  ${({ theme, hasFooter }) => css `
    padding: ${theme.collapseContentPadding};
    background: ${theme.collapseContentBackground};
    ${!hasFooter &&
    css `
        border-radius: 0 0 ${theme.collapseBorderRadius}
          ${theme.collapseBorderRadius};
      `}}
  `};
`;
const ContentBody = (props) => {
    const { children } = props;
    return (React.createElement(StyledContentBody, Object.assign({ className: 'rtk-collapse-content-body' }, props), children));
};
ContentBody.displayName = 'CollapseContentBody';
const StyledFooter = styled.div `
  ${({ theme }) => css `
    background: ${theme.collapseContentBackground};
    padding: ${theme.collapseContentPadding};
    border-radius: 0 0 ${theme.collapseBorderRadius}
      ${theme.collapseBorderRadius};
  `};
`;
const ContentFooter = (props) => {
    const { children } = props;
    return (React.createElement(StyledFooter, Object.assign({ className: 'rtk-collapse-content-footer' }, props), children));
};
ContentFooter.displayName = 'CollapseContentFooter';
const StyledContent = styled.div `
  ${({ theme }) => css `
    background: ${theme.collapseContentBackground};
    border: ${theme.collapseBorder};
    border-color: ${theme.collapseBorderColor};
    border-radius: ${theme.collapseBorderRadius};
    border-top: none;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  `};
`;
const Content$2 = (props) => {
    const { children } = props;
    return (React.createElement(StyledContent, Object.assign({ className: 'rtk-collapse-content' }, props), children));
};
Content$2.displayName = 'CollapseContent';

/**
 * Will ensure that affect is not called until at least the second render
 * of the component
 */
const useAfterMountEffect = (cb, deps) => {
    const didMount = React.useRef(false);
    React.useEffect(() => {
        if (didMount.current) {
            cb();
        }
        else {
            didMount.current = true;
        }
    }, [cb, ...deps]); // eslint-disable-line
};

const colors = {
    black: '#000000',
    body: '#000000',
    bodyDisabled: '#CCCCCC',
    border: '#CCCCCC',
    blue: '#23618E',
    code: '#c41d7f',
    description: '#707F86',
    disabledBackground: '#CCCCCC',
    gray: '#58595B',
    green: '#518042',
    hoverBackground: rgba('#EEEEEE', 0.3),
    label: '#000000',
    orange: '#F58220',
    primary: '#23618E',
    primaryBackground: '#FFFFFF',
    purple: '#893391',
    quaternaryBackground: rgba('#6FA4CB', 0.15),
    red: '#C43836',
    secondary: '#58595B',
    secondaryBackground: '#F1F1F1',
    tableBorder: '#F0F4F7',
    subtitle: '#58595B',
    tag: '#0088CC',
    tertiary: '#F58220',
    tertiaryBackground: '#EEEEEE',
    title: '#000000',
    white: '#FFFFFF',
    yellow: '#EAA543',
};

const getDefaultTheme = (themeColors = colors) => ({
    // ---- Animation ---- //
    animationTimeVeryFast: 0.1,
    animationTimeFast: 0.25,
    animationTimeMedium: 0.5,
    animationTimeSlow: 1,
    // ---- Badge ---- //
    badgeBackgroundGreen: themeColors.green,
    badgeBackgroundRed: themeColors.red,
    badgeBackgroundYellow: themeColors.yellow,
    badgeBackgroundOrange: themeColors.orange,
    badgeBackgroundPurple: themeColors.purple,
    badgeBackgroundBlue: themeColors.blue,
    badgeBackgroundGray: themeColors.gray,
    badgeTextColorDark: themeColors.label,
    badgeTextColorLight: themeColors.white,
    // ---- Button ---- //
    buttonBorderRadius: '4px',
    buttonPadding: '0px 15px',
    buttonFontWeight: '500',
    buttonSmallHeight: '24px',
    buttonSmallFontSize: '12px',
    buttonDefaultHeight: '32px',
    buttonDefaultFontSize: '14px',
    buttonLargeHeight: '44px',
    buttonLargeFontSize: '16px',
    // ---- Primary Button ---- //
    buttonPrimaryBackground: themeColors.primary,
    buttonPrimaryBorder: '1px solid',
    buttonPrimaryBorderColor: 'transparent',
    buttonPrimaryColor: themeColors.white,
    buttonPrimaryHoverBackground: `${darken(0.1, themeColors.primary)}`,
    buttonPrimaryHoverColor: themeColors.white,
    buttonPrimaryActiveBackground: `${darken(0.1, themeColors.primary)}`,
    buttonPrimaryActiveColor: themeColors.white,
    // ---- Secondary Button ---- //
    buttonSecondaryBackground: themeColors.secondary,
    buttonSecondaryBorder: '1px solid',
    buttonSecondaryBorderColor: 'transparent',
    buttonSecondaryColor: themeColors.white,
    buttonSecondaryHoverBackground: `${darken(0.1, themeColors.secondary)}`,
    buttonSecondaryHoverColor: themeColors.white,
    buttonSecondaryActiveBackground: `${darken(0.1, themeColors.secondary)}`,
    buttonSecondaryActiveColor: themeColors.white,
    // ---- Tertiary Button ---- //
    buttonTertiaryBackground: themeColors.tertiary,
    buttonTertiaryBorder: '1px solid',
    buttonTertiaryBorderColor: 'transparent',
    buttonTertiaryColor: themeColors.black,
    buttonTertiaryHoverBackground: `${darken(0.1, themeColors.tertiary)}`,
    buttonTertiaryHoverColor: themeColors.black,
    buttonTertiaryActiveBackground: `${darken(0.1, themeColors.tertiary)}`,
    buttonTertiaryActiveColor: themeColors.black,
    // ---- Danger Button ---- //
    buttonDangerBackground: themeColors.red,
    buttonDangerBorder: '1px solid',
    buttonDangerBorderColor: 'transparent',
    buttonDangerColor: themeColors.white,
    buttonDangerHoverBackground: `${darken(0.1, themeColors.red)}`,
    buttonDangerHoverColor: themeColors.white,
    buttonDangerActiveBackground: `${darken(0.1, themeColors.red)}`,
    buttonDangerActiveColor: themeColors.white,
    // ---- Ghost Button ---- //
    buttonGhostBackground: themeColors.primaryBackground,
    buttonGhostBorder: '1px solid',
    // ----- Link Button ---- //
    buttonLinkBackground: 'transparent',
    buttonLinkBorder: '1px solid',
    buttonLinkBorderColor: 'transparent',
    buttonLinkColor: themeColors.primary,
    buttonLinkHoverBackground: 'transparent',
    buttonLinkHoverColor: themeColors.secondary,
    buttonLinkActiveBackground: 'transparent',
    buttonLinkActiveColor: themeColors.secondary,
    // ---- Checkbox ---- //
    checkboxLineHeight: '16px',
    checkboxMargin: '4px',
    checkboxFontSize: '14px',
    checkboxFontColor: themeColors.body,
    checkboxBorder: `1px solid ${themeColors.border}`,
    checkboxHoverColor: themeColors.primary,
    checkboxHoverBorder: `1px solid ${themeColors.primary}`,
    checkboxCheckedBackground: themeColors.primary,
    checkboxCheckedBorderColor: themeColors.primary,
    checkboxBorderRadius: '4px',
    // ---- Collapse ---- //
    collapseBorder: '1px solid',
    collapseBorderColor: themeColors.border,
    collapseBorderRadius: '4px',
    collapseBoxShadow: 'none',
    collapseContentPadding: '10px',
    collapseContentBackground: themeColors.primaryBackground,
    collapseContentFooterHoverColor: themeColors.tertiaryBackground,
    collapseHeaderColor: themeColors.body,
    collapseHeaderBackground: themeColors.primaryBackground,
    collapseHeaderHoverBackground: themeColors.primary,
    collapseHeaderHoverColor: themeColors.white,
    collapseHeaderOpenBackground: themeColors.primary,
    collapseHeaderOpenColor: themeColors.white,
    collapseHeaderPadding: '0px 15px',
    collapseHeaderHeight: '32px',
    collapseIconSize: '10px',
    // ---- Divider ---- //
    dividerBorder: themeColors.border,
    dividerBackground: themeColors.border,
    dividerTextPrimaryBackground: themeColors.primaryBackground,
    dividerTextColor: themeColors.body,
    // ---- DropPad ---- //
    dropPadPadding: '8px',
    dropPadHoverBackground: `${rgba(themeColors.primary, 0.6)}`,
    dropPadBackground: `${rgba(themeColors.primary, 0.2)}`,
    dropPadBorder: '1px dashed',
    dropPadHoverBorderColor: themeColors.primary,
    dropPadBorderColor: themeColors.primary,
    dropPadBorderRadius: '4px',
    dropPadFileLoadingBackground: themeColors.secondaryBackground,
    dropPadFileLoadingBarBackground: themeColors.primary,
    // ---- Layout ---- //
    layoutHeaderHeight: '44px',
    layoutHeaderPaddingSmall: '0 8px',
    layoutHeaderPaddingMedium: '0 16px',
    layoutHeaderPaddingLarge: '0 24px',
    layoutFooterHeight: '60px',
    layoutSiderWidthSmall: '100px',
    layoutSiderWidthMedium: '200px',
    layoutSiderWidthLarge: '300px',
    // ---- Input ---- //
    inputBackground: themeColors.primaryBackground,
    inputBorder: '1px solid',
    inputBorderRadius: '4px',
    inputBorderColor: themeColors.border,
    inputFocusBorderColor: themeColors.primary,
    inputColor: themeColors.body,
    inputDefaultHeight: '32px',
    inputDefaultFontSize: 14,
    inputDisabledBackground: themeColors.tertiaryBackground,
    inputFontFamily: "'Lato', sans-serif",
    inputStatusErrorBorderColor: themeColors.red,
    inputStatusWarningBorderColor: themeColors.orange,
    inputStatusSuccessBorderColor: themeColors.green,
    inputStatusLoadingBorderColor: themeColors.primary,
    inputSmallHeight: '24px',
    inputSmallFontSize: 12,
    inputLargeHeight: '44px',
    inputLargeFontSize: 18,
    inputPadding: '0 10px',
    inputTextAreaPadding: '10px 10px',
    inputPlaceholderColor: `${rgba(themeColors.body, 0.7)}`,
    // ---- Media Screen ---- //
    mediaScreenSmall: '600px',
    mediaScreenMedium: '748px',
    mediaScreenLarge: '992px',
    mediaScreenVeryLarge: '1200px',
    // ---- Menu ---- //
    menuItemPadding: '4px 16px',
    menuItemHoverColor: themeColors.primary,
    menuItemHoverBackground: themeColors.tertiaryBackground,
    // ---- Modal ---- //
    modalBackground: themeColors.primaryBackground,
    modalBorder: 'none',
    modalBorderColor: 'transparent',
    modalBorderRadius: '4px',
    modalBoxShadow: `0px 4px 12px ${rgba(themeColors.black, 0.15)}`,
    modalContentPadding: '32px',
    modalFooterBackground: themeColors.secondaryBackground,
    modalFooterHeight: '60px',
    modalFooterPadding: '0 32px',
    modalHeaderBackground: 'transparent',
    modalHeaderColor: themeColors.primary,
    modalHeaderMarginTop: '24px',
    modalHeaderPadding: '0 32px',
    modalMaskBackground: `${rgba(themeColors.black, 0.45)}`,
    modalMinHeight: '200px',
    modalMinWidth: '520px',
    // ---- Notification ---- //
    notificationBackground: themeColors.primaryBackground,
    notificationBorderRadius: '4px',
    notificationMinHeight: '46px',
    notificationMinWidth: '350px',
    notificationMaxWidth: '520px',
    notificationBoxShadow: `0px 0px 4px ${rgba(themeColors.black, 0.2)}`,
    // ---- NotificationBox ---- //
    notificationBoxMinHeight: '46px',
    notificationBoxMaxWidth: '520px',
    notificationBoxColor: themeColors.body,
    notificationBoxErrorBackground: '#FAA6A6',
    notificationBoxSuccessBackground: '#C6E3BC',
    notificationBoxWarningBackground: '#F9E6CF',
    notificationBoxInfoBackground: '#AACDE6',
    notificationBoxDefaultBackground: '#CDCDCD',
    notificationBoxBorderRadius: '4px',
    notificationBoxBoxShadow: `0px 0px 4px ${rgba(themeColors.black, 0.2)}`,
    notificationBoxPadding: '8px 16px',
    // ---- Panel ---- //
    panelBackground: themeColors.primaryBackground,
    panelBorder: 'none',
    panelBorderColor: 'transparent',
    panelBorderRadius: '4px',
    panelPadding: '24px',
    panelMargin: '16px',
    panelActiveBoxShadow: `0px 0px 4px ${rgba(themeColors.black, 0.2)}`,
    panelHoverBoxShadow: `0px 7px 21px ${rgba(themeColors.black, 0.07)}`,
    panelWithTitleBorder: '1px solid',
    panelWithTitleBorderColor: themeColors.border,
    // ---- Radio ---- //
    radioItemLineHeight: '16px',
    radioItemMargin: '4px',
    radioItemFontSize: '14px',
    radioItemFontColor: themeColors.body,
    radioItemBorder: `1px solid ${themeColors.border}`,
    radioItemCheckedMiddleBackground: themeColors.primaryBackground,
    radioItemHoverColor: themeColors.primary,
    radioItemHoverBorder: `1px solid ${themeColors.primary}`,
    radioItemCheckedBackground: themeColors.primary,
    radioItemCheckedBorderColor: themeColors.primary,
    // ---- Select ---- //
    selectControlBorderColor: themeColors.border,
    selectControlHoverBorderColor: themeColors.primary,
    selectControlBackground: themeColors.primaryBackground,
    selectControlDisabledBackground: themeColors.disabledBackground,
    selectControlMinHeight: '32px',
    selectOptionColor: themeColors.title,
    selectOptionSelectedBackground: themeColors.tertiaryBackground,
    selectOptionSelectedColor: themeColors.primary,
    selectOptionFocusedBackground: themeColors.quaternaryBackground,
    selectMenuBackground: themeColors.primaryBackground,
    selectMultiValueLabelColor: themeColors.tag,
    selectMultiValueBackground: themeColors.quaternaryBackground,
    selectMultiValueRemoveHoverBackground: themeColors.quaternaryBackground,
    selectSingleValueColor: themeColors.primary,
    // ---- Table ---- //
    tableEmptyContainerHeight: '100px',
    tableHeadBorder: '2px solid',
    tableHeadBorderColor: themeColors.tableBorder,
    tableHeadCellPadding: '8px 16px',
    tableHeadFontSize: '16px',
    tableHeadFontColor: themeColors.subtitle,
    tableBodyCellPadding: '8px 16px',
    tableBodyRowBorder: '1px solid',
    tableBodyRowBorderColor: themeColors.tableBorder,
    tableBodyFontSize: '16px',
    tableBodyFontColor: themeColors.body,
    // ---- Tabs ---- //
    tabsInkbarThickness: '4px',
    tabsInkbarColor: themeColors.orange,
    tabsItemPadding: '8px 16px',
    tabsItemColor: themeColors.white,
    // ---- Toggle ---- //
    toggleHeight: '16px',
    toggleWidth: '32px',
    toggleOffBackground: themeColors.gray,
    toggleOnBackground: themeColors.primary,
    toggleDisabledBackground: `${rgba(themeColors.gray, 0.4)}`,
    toggleOnIconColor: themeColors.white,
    toggleBorderRadius: '8px',
    toggleCircleBackground: themeColors.white,
    toggleCircleHeight: '12px',
    toggleCircleWidth: '12px',
    toggleCircleTop: '2px',
    // ---- Tooltip ---- //
    tooltipBorder: '1px solid',
    tooltipBorderColor: themeColors.border,
    tooltipBorderRadius: '4px',
    tooltipArrowSize: '10px',
    tooltipBoxShadow: `0px 4px 4px ${rgba(themeColors.black, 0.25)}`,
    tooltipMargin: '4px',
    // ---- Typography ---- //
    typographyTitleFontFamily: '"Encode Sans", sans-serif',
    typographyTitle1Color: themeColors.title,
    typographyTitle1FontSize: '36px',
    typographyTitle1FontWeight: '700',
    typographyTitle1LineHeight: '1.1',
    typographyTitle1LetterSpacing: '0',
    typographyTitle2Color: themeColors.title,
    typographyTitle2FontSize: '24px',
    typographyTitle2FontWeight: '700',
    typographyTitle2LineHeight: '1.1',
    typographyTitle2LetterSpacing: '0',
    typographyTitle3Color: themeColors.title,
    typographyTitle3FontSize: '18px',
    typographyTitle3FontWeight: '700',
    typographyTitle3LineHeight: '1.1',
    typographyTitle3LetterSpacing: '0',
    typographyTitle4Color: themeColors.title,
    typographyTitle4FontSize: '16px',
    typographyTitle4FontWeight: '700',
    typographyTitle4LineHeight: '1.1',
    typographyTitle4LetterSpacing: '0',
    typographyTitle5Color: themeColors.title,
    typographyTitle5FontSize: '14px',
    typographyTitle5FontWeight: '700',
    typographyTitle5LineHeight: '1.1',
    typographyTitle5LetterSpacing: '0',
    typographyTitle6Color: themeColors.title,
    typographyTitle6FontSize: '12px',
    typographyTitle6FontWeight: '700',
    typographyTitle6LineHeight: '1.1',
    typographyTitle6LetterSpacing: '0',
    typographySubtitleColor: themeColors.subtitle,
    typographySubtitleFontFamily: '"Lato", sans-serif',
    typographySubtitleFontSize: '16px',
    typographySubtitleFontWeight: '700',
    typographySubtitleLineHeight: '1.5',
    typographySubtitleLetterSpacing: '0',
    typographyBodyColor: themeColors.body,
    typographyBodyFontFamily: '"Lato", sans-serif',
    typographyBodyFontSize: '16px',
    typographyBodyFontWeight: '400',
    typographyBodyLineHeight: '1.5',
    typographyBodyLetterSpacing: '0',
    typographyBodyDisabledColor: themeColors.bodyDisabled,
    typographyDescriptionColor: themeColors.description,
    typographyDescriptionFontFamily: '"Lato", sans-serif',
    typographyDescriptionFontSize: '12px',
    typographyDescriptionFontWeight: '400',
    typographyDescriptionLineHeight: '1.5',
    typographyDescriptionLetterSpacing: '0',
    typographyLabelColor: themeColors.label,
    typographyLabelFontFamily: '"Lato", sans-serif',
    typographyLabelFontSize: '11px',
    typographyLabelFontWeight: '600',
    typographyLabelLineHeight: '1.5',
    typographyLabelLetterSpacing: '0',
    typographyLabelTextTransform: 'uppercase',
    colors: Object.assign({}, themeColors),
});
const createTheme = (colorOverrides, themeOverrides) => {
    const themeColors = Object.assign(Object.assign({}, colors), colorOverrides);
    const theme = getDefaultTheme(themeColors);
    return Object.assign(Object.assign({}, theme), themeOverrides);
};

// theme hook to get the current theme;
const useTheme = () => {
    const theme = createTheme({}, {});
    return React.useContext(ThemeContext) || theme;
};

const useUploadOnMountEffect = ({ file, uploadUrl, itemKey, onFileUploaded, headers, }) => {
    const [percentUploaded, setPercentUploaded] = React.useState(0);
    const [error, setError] = React.useState();
    React.useEffect(() => {
        const xhr = new XMLHttpRequest();
        // while the file is uploading provide updates to the progress
        const onProgressUpdate = (e) => {
            const percentUploaded = Math.round((e.loaded * 100) / e.total);
            setPercentUploaded(percentUploaded);
        };
        // when the file has finished uploading this function will be called
        const onLoad = () => {
            if (onFileUploaded) {
                onFileUploaded(itemKey, JSON.parse(xhr.responseText));
            }
            setPercentUploaded(100);
        };
        // if there is an error during the upload, lets let the user know
        const onError = (e) => {
            setError(e);
        };
        const formData = new FormData();
        formData.append('file', file);
        xhr.open('POST', uploadUrl, true);
        if (headers) {
            headers.forEach((h) => {
                xhr.setRequestHeader(h.header, h.value);
            });
        }
        xhr.send(formData);
        xhr.upload.addEventListener('progress', onProgressUpdate);
        xhr.addEventListener('load', onLoad);
        xhr.addEventListener('error', onError);
        //   // remove event listeners when the component unmounts;
        return () => {
            xhr.upload.removeEventListener('progress', onProgressUpdate);
            xhr.removeEventListener('load', onLoad);
            xhr.removeEventListener('error', onError);
            // if the upload is currently in progress abort it
            // when the component unmounts
            if (percentUploaded > 0 && percentUploaded < 100) {
                xhr.abort();
            }
        };
        //eslint-disable-next-line
    }, []);
    return {
        percentUploaded,
        error,
    };
};

const Container$t = styled.div `
  ${({ disabled, theme }) => css `
    ${disabled &&
    css `
      pointer-events: none;
    `}
    &:hover,
    :focus-within {
      .rtk-collapse-header {
        background: ${theme.collapseHeaderOpenBackground};
        border: 1px solid transparent;
        color: ${theme.collapseHeaderOpenColor};
      }
      .rtk-collapse-content-footer {
        background: ${theme.collapseContentFooterHoverColor};
      }
    }
  `};
  }
`;
const Collapse = ({ disabled, expanded, icon, className, children, defaultExpanded, destroyOnClose, header, footer, itemKey, onChange, }) => {
    const [isExpanded, setExpanded] = React.useState(defaultExpanded);
    const theme = useTheme();
    const onHeaderClick = React.useCallback(() => {
        // if external control of expanded state is not being used
        if (expanded === undefined) {
            setExpanded(!isExpanded);
            if (onChange) {
                onChange(itemKey);
            }
        }
        else if (onChange) {
            onChange(itemKey);
        }
    }, [expanded, isExpanded, itemKey, onChange]);
    // responsible for handling external control of the expanded state
    const handleSetExpanded = React.useCallback(() => {
        if (!disabled) {
            setExpanded(expanded);
        }
        else {
            setExpanded(false);
        }
    }, [disabled, expanded]);
    useAfterMountEffect(handleSetExpanded, [disabled, expanded]);
    return (React.createElement(Container$t, { className: `${className} rtk-collapse`, disabled: disabled, theme: theme },
        React.createElement(Header$3, { disabled: disabled, expanded: isExpanded, icon: icon, onClick: onHeaderClick, theme: theme }, header),
        React.createElement(ContentContainer$1, { animate: isExpanded ? 'open' : 'closed', destroyOnClose: destroyOnClose, theme: theme },
            React.createElement(Content$2, { theme: theme },
                React.createElement(ContentBody, { theme: theme, hasFooter: !!footer }, children),
                footer && React.createElement(ContentFooter, { theme: theme }, footer)))));
};
Collapse.displayName = 'Collapse';
Collapse.defaultProps = {
    disabled: false,
    expanded: undefined,
    children: '',
    className: '',
    defaultExpanded: false,
    destroyOnClose: false,
    header: '',
    onChange: undefined,
    itemKey: '',
};

const AccordionContext = React.createContext({
    expandedItems: [],
});

const CollapseSpacer = styled.div `
  height: ${(props) => `${props.itemGap}px`};
`;
/** Accordion.Item */
const AccordionItem = (props) => (React.createElement(AccordionContext.Consumer, null, (value) => {
    const { itemKey } = props;
    const isExpanded = value.expandedItems.includes(itemKey);
    return (React.createElement(React.Fragment, null,
        React.createElement(Collapse, Object.assign({}, props, { defaultExpanded: isExpanded, expanded: isExpanded, onChange: value.onChange })),
        React.createElement(CollapseSpacer, { itemGap: value.itemGap })));
}));
AccordionItem.displayName = 'AccordionItem';

const Container$s = styled.div ``;
const Accordion = ({ children, classic, className, defaultExpandedItems, itemGap, onChange, expandedItems: customExpandedItems, }) => {
    const [expandedItems, setExpandedItems] = React.useState(defaultExpandedItems || []);
    const onCollapseChange = React.useCallback((key) => {
        // if there is no external control of items
        if (customExpandedItems == null) {
            function getItems(key) {
                return expandedItems.includes(key)
                    ? expandedItems.filter((i) => i !== key)
                    : expandedItems.concat(key);
            }
            function getClassicItems(key) {
                return expandedItems.includes(key) ? [] : [key];
            }
            const newItems = classic ? getClassicItems(key) : getItems(key);
            setExpandedItems(newItems);
        }
        if (onChange) {
            onChange(key);
        }
    }, [expandedItems, customExpandedItems, onChange, classic]);
    return (React.createElement(AccordionContext.Provider, { value: {
            itemGap,
            expandedItems: customExpandedItems || expandedItems,
            onChange: onCollapseChange,
        } },
        React.createElement(Container$s, { className: className }, children)));
};
Accordion.defaultProps = {
    children: '',
    classic: false,
    className: '',
    defaultExpandedItems: [],
    itemGap: 20,
    onChange: undefined,
};
Accordion.Item = AccordionItem;
Accordion.displayName = 'Accordion';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

const StyledButton = styled.button `
  ${({ buttonType, customProps, disabled, theme }) => css `
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    border-radius: ${theme.buttonBorderRadius};
    cursor: pointer;
    font-size: ${theme.buttonDefaultFontSize};
    font-weight: ${theme.buttonFontWeight};
    font-family: Lato, sans-serif;
    height: ${theme.buttonDefaultHeight};
    line-height: 1;
    padding: ${theme.buttonPadding};
    white-space: nowrap;
    outline: 0;
    user-select: none;
    touch-action: manipulation;

    transition: all ${theme.animationTimeFast}s;
    
   -webkit-tap-highlight-color: transparent;
   
   /* // ----------- Size Small --------- // */
    ${customProps.size === 'small' &&
    css `
        font-size: ${theme.buttonSmallFontSize};
        height: ${theme.buttonSmallHeight};
      `}
    
   /* // ----------- Size Large --------- // */
    ${customProps.size === 'large' &&
    css `
        font-size: ${theme.buttonLargeFontSize};
        height: ${theme.buttonLargeHeight};
      `}

    /* // ----------- Primary --------- // */
    ${buttonType === 'primary' &&
    css `
        background: ${theme.buttonPrimaryBackground};
        color: ${theme.buttonPrimaryColor};
        border: ${theme.buttonPrimaryBorder};
        border-color: ${theme.buttonPrimaryBorderColor};

        &:hover,
        &:focus {
          background: ${theme.buttonPrimaryHoverBackground};
          color: ${theme.buttonPrimaryHoverColor};
        }

        &:active {
          background: ${theme.buttonPrimaryActiveBackground};
          color: ${theme.buttonPrimaryActiveColor};
        }

        ${customProps.ghost &&
        css `
          background: ${theme.buttonGhostBackground};
          border: ${theme.buttonGhostBorder};
          border-color: ${theme.buttonPrimaryBackground};
          color: ${theme.buttonPrimaryBackground};

          &:hover,
          &:focus {
            background: ${theme.buttonPrimaryBackground};
            border: ${theme.buttonGhostBorder};
            border-color: transparent;
          }

          ${customProps.loading &&
            css `
            &:hover,
            &:focus {
              background: ${theme.buttonGhostBackground};
              border: ${theme.buttonGhostBorder};
              border-color: ${theme.buttonPrimaryBackground};
              color: ${theme.buttonPrimaryBackground};
            }
          `}

          &:active {
            border: ${theme.buttonGhostBorder};
            border-color: transparent;
          }
        `}
      `};

      /* // ----------- Secondary --------- // */
      ${buttonType === 'secondary' &&
    css `
          background: ${theme.buttonSecondaryBackground};
          color: ${theme.buttonSecondaryColor};
          border: ${theme.buttonSecondaryBorder};
          border-color: ${theme.buttonSecondaryBorderColor};

          &:hover,
          &:focus {
            background: ${theme.buttonSecondaryHoverBackground};
            color: ${theme.buttonSecondaryHoverColor};
          }

          &:active {
            background: ${theme.buttonSecondaryActiveBackground};
            color: ${theme.buttonSecondaryActiveColor};
          }

          ${customProps.ghost &&
        css `
            background: ${theme.buttonGhostBackground};
            border: ${theme.buttonGhostBorder};
            border-color: ${theme.buttonSecondaryBackground};
            color: ${theme.buttonSecondaryBackground};

            &:hover,
            &:focus {
              background: ${theme.buttonSecondaryBackground};
              border: ${theme.buttonGhostBorder};
              border-color: transparent;
            }

            &:active {
              border: ${theme.buttonGhostBorder};
              border-color: transparent;
            }
          `}
        `};

      /* ----------- Tertiary --------- */
      ${buttonType === 'tertiary' &&
    css `
          background: ${theme.buttonTertiaryBackground};
          color: ${theme.buttonTertiaryColor};
          border: ${theme.buttonTertiaryBorder};
          border-color: ${theme.buttonTertiaryBorderColor};

          &:hover,
          &:focus {
            background: ${theme.buttonTertiaryHoverBackground};
            color: ${theme.buttonTertiaryHoverColor};
          }

          &:active {
            background: ${theme.buttonTertiaryActiveBackground};
            color: ${theme.buttonTertiaryActiveColor};
          }

          ${customProps.ghost &&
        css `
            background: ${theme.buttonGhostBackground};
            border: ${theme.buttonGhostBorder};
            border-color: ${theme.buttonTertiaryBackground};
            color: ${theme.buttonTertiaryBackground};

            &:hover,
            &:focus {
              background: ${theme.buttonTertiaryBackground};
              border: ${theme.buttonGhostBorder};
              border-color: transparent;
            }

            &:active {
              border: ${theme.buttonGhostBorder};
              border-color: transparent;
            }
          `}
        `};
    
    /* // ----------- Danger --------- // */
    ${buttonType === 'danger' &&
    css `
        background: ${theme.buttonDangerBackground};
        border: ${theme.buttonDangerBorder};
        border-color: ${theme.buttonDangerBorderColor};
        color: ${theme.buttonDangerColor};

        &:hover,
        &:focus {
          background: ${theme.buttonDangerHoverBackground};
          color: ${theme.buttonDangerHoverColor};
        }

        &:active {
          background: ${theme.buttonDangerActiveBackground};
          color: ${theme.buttonDangerActiveColor};
        }

        ${customProps.ghost &&
        css `
          background: ${theme.buttonGhostBackground};
          border: ${theme.buttonGhostBorder};
          border-color: ${theme.buttonDangerBackground};
          color: ${theme.buttonDangerBackground};

          &:hover,
          &:focus {
            background: ${theme.buttonDangerBackground};
            border: ${theme.buttonGhostBorder};
            border-color: transparent;
          }

          &:active {
            border: ${theme.buttonGhostBorder};
            border-color: transparent;
          }
        `};
      `};
    
    /* // ----------- Link --------- // */
    ${buttonType === 'link' &&
    css `
        background: ${theme.buttonLinkBackground};
        border: ${theme.buttonLinkBorder};
        border-color: ${theme.buttonLinkBorderColor};
        color: ${theme.buttonLinkColor};

        &:hover,
        &:focus {
          background: ${theme.buttonLinkHoverBackground};
          color: ${theme.buttonLinkHoverColor};
          text-decoration: underline;
        }

        &:active {
          background: ${theme.buttonLinkActiveBackground};
          color: ${theme.buttonLinkActiveColor};
          text-decoration: underline;
        }
      `};

    ${(disabled || customProps.loading) &&
    css `
        pointer-events: none;
        opacity: 0.5;
      `};

    /* // ----------- Circle --------- // */
    ${customProps.shape === 'circle' &&
    css `
      padding: 0;
      min-width: ${theme.buttonDefaultHeight};
      text-align: center;
      border-radius: 50%;
      
      // ----------- Size Small --------- //
      ${customProps.size === 'small' &&
        css `
          min-width: ${theme.buttonSmallHeight};
        `}
      
     // ----------- Size Large --------- //
      ${customProps.size === 'large' &&
        css `
          min-width: ${theme.buttonLargeHeight};
        `}

      ${customProps.loading &&
        css `
          span {
            display: none;
          }
        `};
    `}
    
    span {
      pointer-events: none;
    }   

    &::-moz-focus-inner {
      border: none;
    }
  `};
`;

const AngleLeft = (props) => {
    return React.createElement(FontAwesomeIcon, Object.assign({ icon: faAngleLeft }, props));
};

const AngleRight = (props) => {
    return React.createElement(FontAwesomeIcon, Object.assign({ icon: faAngleRight }, props));
};

const ArrowDown = (props) => {
    return React.createElement(FontAwesomeIcon, Object.assign({ icon: faArrowDown }, props));
};

const ArrowUp = (props) => {
    return React.createElement(FontAwesomeIcon, Object.assign({ icon: faArrowUp }, props));
};

const Ban = (props) => {
    return React.createElement(FontAwesomeIcon, Object.assign({ icon: faBan }, props));
};

const Bars = (props) => {
    return React.createElement(FontAwesomeIcon, Object.assign({ icon: faBars }, props));
};

const CaretDown = (props) => {
    return React.createElement(FontAwesomeIcon, Object.assign({ icon: faCaretDown }, props));
};

const Check = (props) => {
    return React.createElement(FontAwesomeIcon, Object.assign({ icon: faCheck }, props));
};

const CheckCircle = (props) => {
    return React.createElement(FontAwesomeIcon, Object.assign({ icon: faCheckCircle }, props));
};

const CheckSquare = (props) => {
    return React.createElement(FontAwesomeIcon, Object.assign({ icon: faCheckSquare }, props));
};

const ChevronUp = (props) => {
    return React.createElement(FontAwesomeIcon, Object.assign({ icon: faChevronUp }, props));
};

const ChevronDown = (props) => {
    return React.createElement(FontAwesomeIcon, Object.assign({ icon: faChevronDown }, props));
};

const ChevronCircleDown = (props) => {
    return React.createElement(FontAwesomeIcon, Object.assign({ icon: faChevronCircleDown }, props));
};

const ChevronCircleUp = (props) => {
    return React.createElement(FontAwesomeIcon, Object.assign({ icon: faChevronCircleUp }, props));
};

const Clipboard = (props) => {
    return React.createElement(FontAwesomeIcon, Object.assign({ icon: faClipboard }, props));
};

const ClipboardList = (props) => {
    return React.createElement(FontAwesomeIcon, Object.assign({ icon: faClipboardList }, props));
};

const Clock = (props) => {
    return React.createElement(FontAwesomeIcon, Object.assign({ icon: faClock }, props));
};

const Clone = (props) => {
    return React.createElement(FontAwesomeIcon, Object.assign({ icon: faClone }, props));
};

const Cog = (props) => {
    return React.createElement(FontAwesomeIcon, Object.assign({ icon: faCog }, props));
};

const Edit = (props) => {
    return React.createElement(FontAwesomeIcon, Object.assign({ icon: faEdit }, props));
};

const Exclamation = (props) => {
    return React.createElement(FontAwesomeIcon, Object.assign({ icon: faExclamation }, props));
};

const ExclamationCircle = (props) => {
    return React.createElement(FontAwesomeIcon, Object.assign({ icon: faExclamationCircle }, props));
};

const ExclamationTriangle = (props) => {
    return React.createElement(FontAwesomeIcon, Object.assign({ icon: faExclamationTriangle }, props));
};

const ExternalLinkAlt = (props) => {
    return React.createElement(FontAwesomeIcon, Object.assign({ icon: faExternalLinkAlt }, props));
};

const EyeSlash = (props) => {
    return React.createElement(FontAwesomeIcon, Object.assign({ icon: faEyeSlash }, props));
};

const File = (props) => {
    return React.createElement(FontAwesomeIcon, Object.assign({ icon: faFile }, props));
};

const FileAlt = (props) => {
    return React.createElement(FontAwesomeIcon, Object.assign({ icon: faFileAlt }, props));
};

const Folder = (props) => {
    return React.createElement(FontAwesomeIcon, Object.assign({ icon: faFolder }, props));
};

const FolderOpen = (props) => {
    return React.createElement(FontAwesomeIcon, Object.assign({ icon: faFolderOpen }, props));
};

const FolderOutline = (props) => {
    return React.createElement(FontAwesomeIcon, Object.assign({ icon: faFolder$1 }, props));
};

const GlobeAmericas = (props) => {
    return React.createElement(FontAwesomeIcon, Object.assign({ icon: faGlobeAmericas }, props));
};

const InfoCircle = (props) => {
    return React.createElement(FontAwesomeIcon, Object.assign({ icon: faInfoCircle }, props));
};

const Loading = (_a) => {
    var { className, color } = _a, props = __rest(_a, ["className", "color"]);
    const theme = useTheme();
    return (React.createElement(FontAwesomeIcon, Object.assign({ className: className, icon: faCircleNotch, color: color || theme.colors.primary, spin: true }, props)));
};

const Lock = (props) => {
    return React.createElement(FontAwesomeIcon, Object.assign({ icon: faLock }, props));
};

const PaperClip = (props) => {
    return React.createElement(FontAwesomeIcon, Object.assign({ icon: faPaperclip }, props));
};

const Pencil = (props) => {
    return React.createElement(FontAwesomeIcon, Object.assign({ icon: faPencilAlt }, props));
};

const PowerOff = (props) => {
    return React.createElement(FontAwesomeIcon, Object.assign({ icon: faPowerOff }, props));
};

const Search = (props) => {
    return React.createElement(FontAwesomeIcon, Object.assign({ icon: faSearch }, props));
};

const ShareSquare = (props) => {
    return React.createElement(FontAwesomeIcon, Object.assign({ icon: faShareSquare }, props));
};

const Container$r = styled.span `
  display: inline-flex;
  flex-direction: column;
  align-items: center;
`;
const UpContainer = styled.span ``;
const DownContainer = styled.span `
  margin-top: -1.5em;
`;
const Sort = ({ state }) => {
    const { colors: { primary, description }, } = useTheme();
    return (React.createElement(Container$r, null,
        React.createElement(UpContainer, null,
            React.createElement(FontAwesomeIcon, { icon: faSortUp, color: state === 'asc' ? primary : description })),
        React.createElement(DownContainer, null,
            React.createElement(FontAwesomeIcon, { icon: faSortDown, color: state === 'dsc' ? primary : description }))));
};

const StickyNote = (props) => {
    return React.createElement(FontAwesomeIcon, Object.assign({ icon: faStickyNote }, props));
};

const SyncAlt = (props) => {
    return React.createElement(FontAwesomeIcon, Object.assign({ icon: faSyncAlt }, props));
};

const Table$1 = (props) => {
    return React.createElement(FontAwesomeIcon, Object.assign({ icon: faTable }, props));
};

const TicketAlt = (props) => {
    return React.createElement(FontAwesomeIcon, Object.assign({ icon: faTicketAlt }, props));
};

const Times = (props) => {
    return React.createElement(FontAwesomeIcon, Object.assign({ icon: faTimes }, props));
};

const TimesCircle = (props) => {
    return React.createElement(FontAwesomeIcon, Object.assign({ icon: faTimesCircle }, props));
};

const TrashAlt = (props) => {
    return React.createElement(FontAwesomeIcon, Object.assign({ icon: faTrashAlt }, props));
};

const Undo = (props) => {
    return React.createElement(FontAwesomeIcon, Object.assign({ icon: faUndo }, props));
};

const WindowClose = (props) => {
    return React.createElement(FontAwesomeIcon, Object.assign({ icon: faWindowClose }, props));
};

const WindowMaximize = (props) => {
    return React.createElement(FontAwesomeIcon, Object.assign({ icon: faWindowMaximize }, props));
};

const Icon = {
    AngleLeft,
    AngleRight,
    ArrowDown,
    ArrowUp,
    Ban,
    Bars,
    CaretDown,
    Check,
    CheckCircle,
    CheckSquare,
    ChevronUp,
    ChevronDown,
    ChevronCircleDown,
    ChevronCircleUp,
    Clipboard,
    ClipboardList,
    Clock,
    Clone,
    Cog,
    Edit,
    Exclamation,
    ExclamationCircle,
    ExclamationTriangle,
    ExternalLinkAlt,
    EyeSlash,
    File,
    FileAlt,
    Folder,
    FolderOpen,
    FolderOutline,
    GlobeAmericas,
    InfoCircle,
    Loading,
    Lock,
    Minus,
    PaperClip,
    Pencil,
    Plus,
    PowerOff,
    Search,
    ShareSquare,
    Sort,
    StickyNote,
    SyncAlt,
    Table: Table$1,
    TicketAlt,
    Times,
    TimesCircle,
    TrashAlt,
    Undo,
    WindowClose,
    WindowMaximize,
};

function getTypeStyle(type, ghost, theme) {
    switch (type) {
        case 'primary': {
            if (ghost) {
                return theme.buttonPrimaryBackground;
            }
            return theme.buttonPrimaryColor;
        }
        case 'danger': {
            if (ghost) {
                return theme.buttonDangerBackground;
            }
            return theme.buttonDangerColor;
        }
        case 'link': {
            return theme.buttonLinkColor;
        }
    }
}
const Button = React.forwardRef((props, ref) => {
    const { children, className, ghost, htmlType, loading, type, shape, size } = props, rest = __rest(props, ["children", "className", "ghost", "htmlType", "loading", "type", "shape", "size"]);
    const theme = useTheme();
    return (React.createElement(StyledButton, Object.assign({ ref: ref, buttonType: type, className: `${className} rtk-button`, customProps: {
            loading,
            ghost,
            shape,
            size,
        }, type: htmlType, theme: theme }, rest),
        loading && (React.createElement(React.Fragment, null,
            React.createElement(Icon.Loading, { color: getTypeStyle(type, ghost, theme) }),
            React.createElement(motion.div, { key: 'loading', animate: {
                    marginRight: shape === 'circle' ? 0 : 5,
                    transition: { type: 'tween' },
                }, transition: {
                    type: 'tween',
                    duration: theme.animationTimeVeryFast,
                } }))),
        React.createElement("span", null, children)));
});
Button.displayName = 'Button';
Button.defaultProps = {
    type: 'primary',
    children: '',
    className: '',
    disabled: false,
    ghost: false,
    loading: false,
    onClick: undefined,
    shape: 'default',
    size: 'default',
    htmlType: 'button',
};

function getThemeColor(theme, color) {
    switch (color) {
        case 'green':
            return theme.badgeBackgroundGreen;
        case 'red':
            return theme.badgeBackgroundRed;
        case 'blue':
            return theme.badgeBackgroundBlue;
        case 'yellow':
            return theme.badgeBackgroundYellow;
        case 'orange':
            return theme.badgeBackgroundOrange;
        case 'purple':
            return theme.badgeBackgroundPurple;
        case 'gray':
            return theme.badgeBackgroundGray;
        default:
            return theme.badgeBackgroundGreen;
    }
}
function needsDarkText(theme, color) {
    return color === 'yellow' || color === 'orange';
}
const StyledBadge = styled.span `
  ${({ backgroundColor, theme }) => css `
    padding: 4px 10px 4px 9px;
    border-radius: 16px;
    white-space: nowrap;
    font-weight: bold;
    border: 0px;
    color: ${needsDarkText(theme, backgroundColor)
    ? theme.badgeTextColorDark
    : theme.badgeTextColorLight};
    background: ${getThemeColor(theme, backgroundColor)};
  `};
`;
const SeparateContents = styled.span `
  margin-right: 4px;
`;
const SeparateRight = styled.span `
  margin-left: 4px;
`;
const Badge = (_a) => {
    var { children, rightChildren, leftChildren, className } = _a, rest = __rest(_a, ["children", "rightChildren", "leftChildren", "className"]);
    const theme = useTheme();
    return (React.createElement(StyledBadge, Object.assign({ className: className, theme: theme }, rest),
        leftChildren && React.createElement(SeparateContents, null, leftChildren),
        children,
        rightChildren && React.createElement(SeparateRight, null, rightChildren)));
};
Badge.displayName = 'Badge';
Badge.defaultProps = {
    className: '',
    rightChildren: null,
    leftChildren: null,
    backgroundColor: 'green',
};

const Container$q = styled.div `
  ${({ disabled }) => disabled &&
    css `
      pointer-events: none;
      opacity: 0.6;
    `}
`;
const StyledLabel$2 = styled.label `
  position: relative;
  display: inline-block;

  line-height: ${({ theme }) => theme.checkboxLineHeight};
  margin: ${({ theme }) => theme.checkboxMargin};

  font-family: 'Lato', sans-serif;

  input {
    display: none;
  }

  span {
    font-size: ${({ theme }) => theme.checkboxFontSize};
    color: ${({ theme }) => theme.checkboxFontColor};
    transition: all ${({ theme }) => theme.animationTimeVeryFast}s ease-in-out;
    padding-left: 24px;

    &::before {
      content: '';

      position: absolute;
      display: block;
      top: 0;
      left: 0;

      height: 16px;
      width: 16px;
      border: ${({ theme }) => theme.checkboxBorder};
      border-radius: ${({ theme }) => theme.checkboxBorderRadius};
      box-sizing: border-box;
      transition: all ${({ theme }) => theme.animationTimeVeryFast}s ease-in-out;
    }

    &::after {
      content: '';

      position: absolute;
      display: block;
      left: 5px;
      top: 2px;
      width: 3px;
      height: 7px;
      border: solid white;
      border-width: 0 3px 3px 0;
      transform: rotate(45deg);

      transition: all ${({ theme }) => theme.animationTimeVeryFast}s ease-in-out;
      visibility: hidden;
    }
  }

  input[type='checkbox']:hover + span {
    &::before {
      border: ${({ theme }) => theme.checkboxHoverBorder};
    }
  }

  input[type='checkbox']:checked + span {
    &::before {
      background: ${({ theme }) => theme.checkboxCheckedBackground};
      border-color: ${({ theme }) => theme.checkboxCheckedBorderColor};
    }

    &::after {
      visibility: visible;
    }
  }
`;
const Checkbox = ({ checked, children, disabled, name, onChange, }) => {
    const theme = useTheme();
    const handleChange = React.useCallback((e) => {
        const { name, checked } = e.target;
        if (onChange) {
            onChange({ name, checked });
        }
    }, [onChange]);
    const isChecked = React.useMemo(() => {
        if (checked) {
            return checked;
        }
        return undefined;
    }, [checked]);
    return (React.createElement(Container$q, { disabled: disabled },
        React.createElement(StyledLabel$2, { theme: theme },
            React.createElement("input", { type: "checkbox", name: name, onChange: handleChange, checked: isChecked }),
            React.createElement("span", null, children))));
};
Checkbox.displayName = 'Checkbox';

styled.li `
  ${() => css `
    display: inline-block;
    vertical-align: middle;
  `};
`;
const StyledDivider = styled.hr `
  ${({ customProps, theme, height }) => css `
    width: 100%;
    color: ${theme.dividerTextColor}
      ${customProps.orientation === 'vertical' &&
    css `
        margin: 2px 5px 0 5px;
        width: auto;
        color: ${theme.dividerBorder};
        height: inherit;

        ${customProps.margin &&
        css `
          margin: 2px ${customProps.margin} 0 ${customProps.margin};
        `}
      `};

    ${(customProps.orientation === 'horizontal' || !customProps.orientation) &&
    css `
      ${customProps.margin &&
        css `
        margin: ${customProps.margin} 0;
        color: ${theme.dividerBorder};
      `}
    `};

    ${customProps.thickness &&
    css `
      border-top: ${customProps.thickness} solid ${theme.dividerBorder};
    `};

    ${customProps.thickness &&
    customProps.orientation === 'vertical' &&
    css `
      border-left: ${customProps.thickness} solid;
    `};

    ${customProps.text &&
    css `
      position: relative;
      line-height: 1rem;
      outline: 0;
      border: 0;
      height: 1rem;
      border-left: 0;
      display: flex;
      justify-content: center;
      border-top: unset;

      ${customProps.fontSize &&
        css `
        line-height: ${height}rem;
        height: ${height}rem;
      `};

      &:before {
        content: '';
        position: absolute;
        width: 100%;
        top: 50%;
        left: 0;
        height: 1px;
        transform: translateY(-50%);
        background: linear-gradient(
          to right,
          ${theme.dividerBackground},
          ${theme.dividerBackground},
          ${theme.dividerBackground}
        );
      }

      &:after {
        content: attr(data-content);
        position: absolute;
        background: ${theme.dividerTextPrimaryBackground};
        padding: 0 0.5em;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
      }
    `};

    ${customProps.thickness !== '1px' &&
    css `
      &:before {
        height: ${customProps.thickness};
      }
    `};

    ${customProps.textAlign === 'left' &&
    css `
      justify-content: flex-start;
      padding-left: 30px;
    `};

    ${customProps.textAlign === 'right' &&
    css `
      justify-content: flex-end;
      padding-right: 30px;
    `};

    ${customProps.bgColor &&
    css `
      &:after {
        background: ${customProps.bgColor};
      }
    `};

    ${customProps.fontSize &&
    css `
      &:after {
        font-size: ${customProps.fontSize}rem;
      }
    `};
  `};
`;

const Divider = (props) => {
    const { component, orientation, className, margin, thickness, text, textAlign, bgColor, fontSize } = props, rest = __rest(props, ["component", "orientation", "className", "margin", "thickness", "text", "textAlign", "bgColor", "fontSize"]);
    const theme = useTheme();
    const DividerWrapper = component === 'li' ? 'li' : React.Fragment;
    return (React.createElement(DividerWrapper, null,
        React.createElement(StyledDivider, Object.assign({ height: fontSize, customProps: {
                component,
                orientation,
                margin,
                thickness,
                text,
                textAlign,
                bgColor,
                fontSize,
            }, className: `${className} rtk-divider`, theme: theme, "data-content": text }, rest))));
};
Divider.displayName = 'Divider';
Divider.defaultProps = {
    component: '',
    orientation: 'horizontal',
    className: '',
    margin: '',
    thickness: '1px',
    text: '',
    textAlign: 'center',
    bgColor: '',
    fontSize: 1,
};

// styles for h1
const h1Styles = css `
  font-family: ${({ theme }) => theme.typographyTitleFontFamily};
  color: ${({ theme }) => theme.typographyTitle1Color};
  font-size: ${({ theme }) => theme.typographyTitle1FontSize};
  font-weight: ${({ theme }) => theme.typographyTitle1FontWeight};
  letter-spacing: ${({ theme }) => theme.typographyTitle1LetterSpacing};
  line-height: ${({ theme }) => theme.typographyTitle1LineHeight};
  user-select: none;
`;
// styles for h2
const h2Styles = css `
  font-family: ${({ theme }) => theme.typographyTitleFontFamily};
  color: ${({ theme }) => theme.typographyTitle2Color};
  font-size: ${({ theme }) => theme.typographyTitle2FontSize};
  font-weight: ${({ theme }) => theme.typographyTitle2FontWeight};
  letter-spacing: ${({ theme }) => theme.typographyTitle2LetterSpacing};
  line-height: ${({ theme }) => theme.typographyTitle2LineHeight};
  user-select: none;
`;
// styles for h3
const h3Styles = css `
  font-family: ${({ theme }) => theme.typographyTitleFontFamily};
  color: ${({ theme }) => theme.typographyTitle3Color};
  font-size: ${({ theme }) => theme.typographyTitle3FontSize};
  font-weight: ${({ theme }) => theme.typographyTitle3FontWeight};
  letter-spacing: ${({ theme }) => theme.typographyTitle3LetterSpacing};
  line-height: ${({ theme }) => theme.typographyTitle3LineHeight};
  user-select: none;
`;
// styles for h4
const h4Styles = css `
  font-family: ${({ theme }) => theme.typographyTitleFontFamily};
  color: ${({ theme }) => theme.typographyTitle4Color};
  font-size: ${({ theme }) => theme.typographyTitle4FontSize};
  font-weight: ${({ theme }) => theme.typographyTitle4FontWeight};
  letter-spacing: ${({ theme }) => theme.typographyTitle4LetterSpacing};
  line-height: ${({ theme }) => theme.typographyTitle4LineHeight};
  user-select: none;
`;
// styles for h5
const h5Styles = css `
  font-family: ${({ theme }) => theme.typographyTitleFontFamily};
  color: ${({ theme }) => theme.typographyTitle5Color};
  font-size: ${({ theme }) => theme.typographyTitle5FontSize};
  font-weight: ${({ theme }) => theme.typographyTitle5FontWeight};
  letter-spacing: ${({ theme }) => theme.typographyTitle5LetterSpacing};
  line-height: ${({ theme }) => theme.typographyTitle5LineHeight};
  user-select: none;
`;
// styles for h6
const h6Styles = css `
  font-family: ${({ theme }) => theme.typographyTitleFontFamily};
  color: ${({ theme }) => theme.typographyTitle6Color};
  font-size: ${({ theme }) => theme.typographyTitle6FontSize};
  font-weight: ${({ theme }) => theme.typographyTitle6FontWeight};
  letter-spacing: ${({ theme }) => theme.typographyTitle6LetterSpacing};
  line-height: ${({ theme }) => theme.typographyTitle6LineHeight};
  user-select: none;
`;
const StyledTitle$1 = styled.div `
  ${({ level }) => level === 1 &&
    css `
      ${h1Styles};
    `}
  
  ${({ level }) => level === 2 &&
    css `
      ${h2Styles};
    `}
  
  ${({ level }) => level === 3 &&
    css `
      ${h3Styles};
    `}
  
  ${({ level }) => level === 4 &&
    css `
      ${h4Styles};
    `}
  
  ${({ level }) => level === 5 &&
    css `
      ${h5Styles};
    `}
      
  ${({ level }) => level === 6 &&
    css `
      ${h6Styles};
    `}
`;
const Title$2 = ({ children, className, level, }) => {
    const theme = useTheme();
    return (React.createElement(StyledTitle$1, { className: `${className} rtk-type-title-h${level}`, theme: theme, level: level }, children));
};
Title$2.displayName = 'Title';
Title$2.defaultProps = {
    level: 1,
};

const StyledSubtitle$1 = styled.div `
  ${({ theme }) => css `
    user-select: none;

    color: ${theme.typographySubtitleColor};
    font-family: ${theme.typographySubtitleFontFamily};
    font-size: ${theme.typographySubtitleFontSize};
    font-weight: ${theme.typographySubtitleFontWeight};
    letter-spacing: ${theme.typographySubtitleLetterSpacing};
    line-height: ${theme.typographySubtitleLineHeight};
  `}
`;
const Subtitle = ({ children, className, }) => {
    const theme = useTheme();
    return (React.createElement(StyledSubtitle$1, { className: `${className} rtk-type-subtitle`, theme: theme }, children));
};
Subtitle.displayName = 'Subtitle';

const bodyStyles = css `
  color: ${({ theme }) => theme.typographyBodyColor};
  font-family: ${({ theme }) => theme.typographyBodyFontFamily};
  font-size: ${({ theme }) => theme.typographyBodyFontSize};
  font-weight: ${({ theme }) => theme.typographyBodyFontWeight};
  letter-spacing: ${({ theme }) => theme.typographyBodyLetterSpacing};
  line-height: ${({ theme }) => theme.typographyBodyLineHeight};

  ${({ disabled }) => disabled &&
    css `
      color: ${({ theme }) => theme.typographyBodyDisabledColor};
    `}
`;
const StyledBody = styled.div `
  ${bodyStyles};
`;
const Body$1 = React.forwardRef((props, ref) => {
    const { className, disabled, children } = props;
    const theme = useTheme();
    return (React.createElement(StyledBody, { className: `${className} rtk-type-body`, theme: theme, disabled: disabled, ref: ref }, children));
});
Body$1.displayName = 'Body';

const StyledDescription = styled.div `
  ${({ theme }) => css `
    user-select: none;

    color: ${theme.typographyDescriptionColor};
    font-family: ${theme.typographyDescriptionFontFamily};
    font-size: ${theme.typographyDescriptionFontSize};
    font-weight: ${theme.typographyDescriptionFontWeight};
    letter-spacing: ${theme.typographyDescriptionLetterSpacing};
    line-height: ${theme.typographyDescriptionLineHeight};
  `}
`;
const Description$1 = ({ children, className, otherProps, }) => {
    const theme = useTheme();
    return (React.createElement(StyledDescription, Object.assign({ className: `${className} rtk-type-description`, theme: theme }, otherProps), children));
};
Description$1.displayName = 'Description';

const StyledLabel$1 = styled.label `
  ${({ theme }) => css `
    user-select: none;

    text-transform: ${theme.typographyLabelTextTransform};
    color: ${theme.typographyLabelColor};
    font-family: ${theme.typographyLabelFontFamily};
    font-size: ${theme.typographyLabelFontSize};
    font-weight: ${theme.typographyLabelFontWeight};
    letter-spacing: ${theme.typographyLabelLetterSpacing};
    line-height: ${theme.typographyLabelLineHeight};
  `}
`;
const Label$1 = ({ children, className, }) => {
    const theme = useTheme();
    return (React.createElement(StyledLabel$1, { className: `${className} rtk-type-label`, theme: theme }, children));
};
Label$1.displayName = 'Label';

const Typography = {
    Title: Title$2,
    Subtitle,
    Body: Body$1,
    Description: Description$1,
    Label: Label$1,
};

const Container$p = styled.div `
  padding: 8px;
  background: ${({ theme }) => theme.dropPadBackground};
  border-radius: ${({ theme }) => theme.dropPadBorderRadius};

  margin-top: 8px;
`;
const ContentContainer = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
const TextContainer = styled.div `
  display: flex;
  align-items: center;
`;
const StyledFileIcon = styled(File) `
  margin-right: 8px;
  color: ${({ theme }) => theme.colors.primary};
`;
const StyledTrashIcon = styled(TrashAlt) `
  color: ${({ theme }) => theme.colors.primary};
  padding: 4px;
  cursor: pointer;
`;
const LoadingBarContainer = styled.div `
  position: relative;
  background: ${({ theme }) => theme.dropPadFileLoadingBackground};
  height: 4px;
  border-radius: 2px;

  margin-top: 8px;
`;
const LoadingBar = styled.div `
  position: absolute;
  background: ${({ theme }) => theme.dropPadFileLoadingBarBackground};
  height: 4px;
  border-radius: 2px;
`;
const DropPadFile = ({ name, itemKey, percentUploaded, onDelete, }) => {
    const theme = useTheme();
    const handleDelete = React.useCallback(() => {
        if (onDelete) {
            onDelete(itemKey);
        }
    }, [onDelete, itemKey]);
    return (React.createElement(Container$p, { key: itemKey, theme: theme },
        React.createElement(ContentContainer, null,
            React.createElement(TextContainer, null,
                React.createElement(StyledFileIcon, { theme: theme, size: 'lg' }),
                React.createElement(Typography.Body, null,
                    React.createElement("strong", null, name))),
            React.createElement(StyledTrashIcon, { onClick: handleDelete, theme: theme, size: '1x', inverse: true })),
        React.createElement(LoadingBarContainer, { theme: theme },
            React.createElement(LoadingBar, { style: { width: `${percentUploaded}%` }, theme: theme }))));
};

const Container$o = styled.div ``;
const DropPadContainer = styled.div `
  min-height: 100px;
  background: ${({ theme, isDragActive }) => isDragActive ? theme.dropPadHoverBackground : theme.dropPadBackground};
  padding: ${({ theme }) => theme.dropPadPadding};
  border-radius: ${({ theme }) => theme.dropPadBorderRadius};

  height: 3em;

  transition: background ${({ theme }) => theme.animationTimeVeryFast}s
    ease-in-out;

  cursor: pointer;
`;
const BorderContainer = styled.div `
  height: 100%;
  width: 100%;

  border: ${({ theme }) => theme.dropPadBorder};
  border-color: ${({ theme, isDragActive }) => isDragActive ? theme.dropPadHoverBorderColor : theme.dropPadBorderColor};
  border-radius: ${({ theme }) => theme.dropPadBorderRadius};

  display: flex;
  align-items: center;
  justify-content: center;
`;
const StyledPaperClip = styled(PaperClip) `
  margin-right: 8px;
`;
const DropPad = ({ className, children, hideDroppad, onDrop, }) => {
    const handleDrop = React.useCallback((files) => {
        if (onDrop) {
            onDrop(files);
        }
    }, [onDrop]);
    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop: handleDrop,
    });
    const theme = useTheme();
    return (React.createElement(Container$o, { className: `${className} rtk-drop-pad` },
        !hideDroppad && (React.createElement(DropPadContainer, Object.assign({}, getRootProps(), { isDragActive: isDragActive, theme: theme }),
            React.createElement(BorderContainer, { theme: theme, isDragActive: isDragActive },
                React.createElement("input", Object.assign({}, getInputProps())),
                React.createElement(Typography.Body, null,
                    React.createElement(StyledPaperClip, null),
                    React.createElement("strong", null, "Choose a file"),
                    "\u00A0to attach or drag it here.")))),
        children));
};
DropPad.File = DropPadFile;
DropPad.displayName = 'DropPad';

const Portal = (props) => {
    const { children, container, disablePortal } = props;
    const [mountNode, setMountNode] = React.useState(null);
    const getContainer = React.useCallback(() => {
        if (container) {
            return container();
        }
    }, [container]);
    React.useEffect(() => {
        if (!disablePortal) {
            setMountNode(getContainer() || document.body);
        }
    }, [getContainer, disablePortal]);
    if (disablePortal) {
        React.Children.only(children);
        return React.cloneElement(children);
    }
    return mountNode ? ReactDOM.createPortal(children, mountNode) : mountNode;
};
Portal.displayName = 'Portal';
Portal.defaultProps = {
    children: '',
    disablePortal: false,
};

// gets the scroll distance for the given axis
function getScroll(w, isTop) {
    let value = w[`page${isTop ? 'Y' : 'X'}Offset`];
    const method = `scroll${isTop ? 'Top' : 'Left'}`;
    if (typeof value !== 'number') {
        const d = w.document;
        value = d.documentElement[method];
        if (typeof value !== 'number') {
            value = d.body[method];
        }
    }
    return value;
}
// gets the total left scroll distance
function getScrollLeft(w) {
    return getScroll(w, false);
}
// gets the total top scroll distance
function getScrollTop(w) {
    return getScroll(w, true);
}
// returns the window object for the given element
function getWindow(element) {
    const doc = element.ownerDocument;
    if (doc) {
        return doc.defaultView;
    }
}
// gets the the region of the element in space by taking into account the current scroll position
function getRegion(element) {
    let x;
    let y;
    const doc = element.ownerDocument;
    const body = doc && doc.body;
    const docElem = doc && doc.documentElement;
    const win = getWindow(element);
    const box = element.getBoundingClientRect();
    x = box.left;
    y = box.top;
    x -= (docElem && docElem.clientLeft) || (body && body.clientLeft) || 0;
    y -= (docElem && docElem.clientTop) || (body && body.clientTop) || 0;
    x += getScrollLeft(win);
    y += getScrollTop(win);
    return {
        left: Number(x.toFixed(0)),
        top: Number(y.toFixed(0)),
        height: box.height,
        width: box.width,
    };
}
// gets the anchor from the anchor
/*
          tc
tl  *-----*-----*  tr
    |     cc    |
cl  *-----*-----*  cr
    |           |
bl  *-----*-----*  br
          bc
*/
function getPoint(anchorPoint, anchorRegion) {
    const verticalPoint = anchorPoint.charAt(0);
    const horizontalPoint = anchorPoint.charAt(1);
    const regionHeight = anchorRegion.height;
    const regionWidth = anchorRegion.width;
    let x = anchorRegion.left;
    let y = anchorRegion.top;
    if (verticalPoint === 'c') {
        y += regionHeight / 2;
    }
    else if (verticalPoint === 'b') {
        y += regionHeight;
    }
    if (horizontalPoint === 'c') {
        x += regionWidth / 2;
    }
    else if (horizontalPoint === 'r') {
        x += regionWidth;
    }
    return {
        top: Number(y.toFixed(0)),
        left: Number(x.toFixed(0)),
    };
}
// position of the floater relative to the anchor point
function getFloaterPosition(anchorRegion, floaterRegion, anchorPoint, floaterPoint, isRelative) {
    // total diff
    const xdi = anchorPoint.left - floaterPoint.left;
    const ydi = anchorPoint.top - floaterPoint.top;
    // viewport diff
    const xv = xdi + floaterRegion.left - (isRelative ? anchorRegion.left : 0);
    const yv = ydi + floaterRegion.top - (isRelative ? anchorRegion.top : 0);
    return {
        top: yv,
        left: xv,
    };
}
function calculateRelativePosition(anchorElement, floaterElement, position, isRelative) {
    // current position of the anchor
    const anchorRegion = getRegion(anchorElement);
    const floaterRegion = getRegion(floaterElement);
    // get anchor point to attach floater to
    const anchorPoint = getPoint(position[0], anchorRegion);
    // get floater point to attach to anchor
    const floaterPoint = getPoint(position[1], floaterRegion);
    return getFloaterPosition(anchorRegion, floaterRegion, anchorPoint, floaterPoint, isRelative);
}
const getRelativePosition = (anchorElement, floaterElement, position, container) => {
    if (container) {
        const win = getWindow(container);
        const style = win && win.getComputedStyle(container);
        if (style && style.position === 'relative') {
            return calculateRelativePosition(anchorElement, floaterElement, position, true);
        }
    }
    return calculateRelativePosition(anchorElement, floaterElement, position, false);
};

const Container$n = styled.div `
  visibility: ${(props) => (props.portalVisibility ? 'visible' : 'hidden')};
`;
const Floater = (props) => {
    const { anchorElement, animationProps, children, container, disableFloater, floaterKey, matchAnchorWidth, open, position, style, } = props;
    const [portalElement, setPortalElement,] = React.useState(null);
    const [portalPosition, setPortalPosition] = React.useState(null);
    // set the ref when react calls it back
    const handleRef = React.useCallback((ref) => {
        setPortalElement(ref);
    }, [setPortalElement]);
    // get the container for floater to mount to
    const getContainer = React.useCallback(() => {
        if (typeof container === 'function') {
            return container();
        }
        return null;
    }, [container]);
    // update the portal position
    const updatePortalPosition = React.useCallback(() => {
        if (portalElement && anchorElement) {
            const container = getContainer();
            const portalPosition = getRelativePosition(anchorElement, portalElement, position, container ? container : undefined);
            setPortalPosition(portalPosition);
        }
    }, [getContainer, position, portalElement, anchorElement]);
    // subscribe to window size
    // const windowSize = useResizeEffect();
    // on open changes, update the portal position
    React.useEffect(() => {
        if (open) {
            updatePortalPosition();
        }
        else {
            setPortalPosition(null);
        }
    }, [open, updatePortalPosition]);
    const portalVisibility = portalElement !== null && portalPosition !== null;
    return (React.createElement(AnimatePresence, null, open && anchorElement && (React.createElement(Portal, { container: getContainer, disablePortal: disableFloater },
        React.createElement(motion.div, Object.assign({ key: floaterKey, ref: handleRef, style: Object.assign(Object.assign({ position: 'absolute', width: matchAnchorWidth
                    ? `${anchorElement.offsetWidth}px`
                    : 'auto', top: -999, left: -999 }, portalPosition), style) }, animationProps),
            React.createElement(Container$n, { portalVisibility: portalVisibility, className: "rtk-floater" }, children))))));
};
Floater.displayName = 'Floater';
Floater.defaultProps = {
    animationProps: {
        initial: { opacity: 0 },
        animate: { opacity: 1 },
        exit: { opacity: 0 },
        transition: { duration: 0.1 },
    },
    disableFloater: false,
    container: undefined,
    floaterKey: 'floater',
    matchAnchorWidth: false,
    open: false,
    position: ['bc', 'tc'],
};

const Container$m = styled.div `
  width: 100%;
`;
const Label = styled(Typography.Label) `
  ${({ theme, required }) => css `
    ${required &&
    css `
      ::before {
        content: '* ';
        color: ${theme.colors.red};
      }
    `}
  `};
`;
const Description = styled(Typography.Description) `
  ${() => css `
    margin-bottom: 4px;
  `};
`;
styled.div `
  position: relative;
  width: 100%;
`;
styled.div `
  ${({ theme, size }) => css `
    position: absolute;
    display: flex;
    align-items: center;
    height: ${theme.inputDefaultHeight};
    left: ${theme.inputPrefixLeft};
    svg {
      width: ${theme.inputDefaultFontSize}px;
      height: ${theme.inputDefaultFontSize}px;
    }

    ${size === 'small' &&
    css `
      height: ${theme.inputSmallHeight};
      svg {
        width: ${theme.inputSmallFontSize}px;
        height: ${theme.inputSmallFontSize}px;
      }
    `}

    ${size === 'large' &&
    css `
      height: ${theme.inputLargeHeight};
      svg {
        width: ${theme.inputLargeFontSize}px;
        height: ${theme.inputLargeFontSize}px;
      }
    `}
  `};
`;
styled.div `
  height: ${({ theme }) => theme.inputStatusMessageHeight};
`;
const inputStyles = css `
  ${({ borderType, theme, type, inputSize, status }) => css `
    height: ${theme.inputDefaultHeight};               
    font-size: ${theme.inputDefaultFontSize}px;
    
    width: 100%;
    -webkit-appearance: none;
    font-family: ${theme.inputFontFamily};
    
    background: ${theme.inputBackground};
    color: ${theme.inputColor};
    
    padding: ${theme.inputPadding};
    border: ${theme.inputBorder};
    border-color: ${theme.inputBorderColor};
    border-radius: ${theme.inputBorderRadius};
    border-color: ${theme.inputBorderColor};
    box-sizing: border-box;
    
    transition: border ${theme.animationTimeFast}s;
    
    ${inputSize === 'small' &&
    css `
        height: ${theme.inputSmallHeight};
        font-size: ${theme.inputSmallFontSize}px;
      `}
    
    ${inputSize === 'large' &&
    css `
        height: ${theme.inputLargeHeight};
        font-size: ${theme.inputLargeFontSize}px;
      `}
    ${type === 'textarea' &&
    css `
        height: 6em;
        padding: ${theme.inputTextAreaPadding};
        resize: vertical;
      `}
    
    ${borderType === 'bottom' &&
    css `
        padding: 10px 5px;
        background: transparent;
        border: none;
        border-radius: 0;
        border-bottom: ${theme.inputBorder};
        border-color: ${theme.inputBorderColor};
      `};
    
    ${borderType === 'none' &&
    css `
        padding: 10px 0;
        background: transparent;
        border: none;
        color: ${theme.inputColor};
      `};
    ${status === 'error' &&
    css `
        border-color: ${theme.inputStatusErrorBorderColor};
      `};
    ${status === 'success' &&
    css `
        border-color: ${theme.inputStatusSuccessBorderColor};
      `};
      
    ${status === 'warning' &&
    css `
        border-color: ${theme.inputStatusWarningBorderColor};
      `};
    
    ${status === 'loading' &&
    css `
        border-color: ${theme.inputStatusLoadingBorderColor};
      `};
    &:read-only {
      cursor: pointer;
    }
    &::placeholder {
      color: ${theme.inputPlaceholderColor};
    }
    &:disabled {
      background: ${theme.inputDisabledBackground};
      cursor: not-allowed;
      opacity: 0.5;
    }
    &:focus {
      border-color: ${theme.inputFocusBorderColor};
      ${borderType === 'bottom' &&
    css `
          border: none;
          border-bottom: 1px solid ${theme.inputFocusBorderColor};
          border-radius: 0;
        `};
      ${borderType === 'none' &&
    css `
          border: none;
        `};
      outline: none;
    }
  `};
`;
const InputWithStyles = styled.input `
  ${inputStyles};
`;
const TextAreaWithStyles = styled.textarea `
  ${inputStyles};
  height: auto;
`;
const StyledInput = (props) => {
    const { type } = props;
    if (type === 'textarea') {
        return React.createElement(TextAreaWithStyles, Object.assign({}, props));
    }
    return React.createElement(InputWithStyles, Object.assign({}, props));
};

const FormItemContext = React.createContext({});

const Input = React.forwardRef((props, ref) => {
    const { className, disabled, defaultValue, description, htmlType, id, label, name, onBlur, onChange, onClick, onFocus, placeholder, size, borderType, readOnly, required, rows, value, } = props;
    const theme = useTheme();
    const { status } = React.useContext(FormItemContext);
    return (React.createElement(Container$m, { className: `${className} rtk-input` },
        label && (React.createElement(Label, { required: required, theme: theme }, label)),
        description && React.createElement(Description, { theme: theme }, description),
        React.createElement(StyledInput, { label: null, disabled: disabled, defaultValue: defaultValue, type: htmlType, id: id, name: name, onBlur: onBlur, onClick: onClick, onChange: onChange, onFocus: onFocus, placeholder: placeholder, borderType: borderType, inputSize: size, ref: ref, rows: rows, readOnly: readOnly, theme: theme, value: value, status: status })));
});
Input.displayName = 'Input';
Input.defaultProps = {
    borderType: 'full',
    className: '',
    disabled: false,
    defaultValue: undefined,
    htmlType: undefined,
    id: undefined,
    name: undefined,
    label: '',
    onBlur: undefined,
    onClick: undefined,
    onChange: undefined,
    onFocus: undefined,
    placeholder: '',
    size: 'default',
    readOnly: false,
    required: false,
    value: undefined,
};

const Container$l = styled.div `
  ${({ theme }) => css `
    height: ${theme.layoutHeaderHeight};

    display: flex;
    align-items: center;

    padding: ${theme.layoutHeaderPaddingLarge};

    @media (max-width: ${theme.mediaScreenMedium}) {
      padding: ${theme.layoutHeaderPaddingMedium};
    }

    @media (max-width: ${theme.mediaScreenSmall}) {
      padding: ${theme.layoutHeaderPaddingSmall};
    }
  `}
`;
const Header$2 = ({ children, className, }) => {
    const theme = useTheme();
    return (React.createElement(Container$l, { className: `${className} rtk-layout-header`, theme: theme }, children));
};
Header$2.displayName = 'LayoutHeader';

const Container$k = styled.div `
  ${() => css `
    flex: 1;
  `}
`;
const Content$1 = ({ children, className, }) => {
    const theme = useTheme();
    return (React.createElement(Container$k, { className: `${className} rtk-layout-content`, theme: theme }, children));
};
Content$1.displayName = 'LayoutContent';

const Container$j = styled.div `
  ${({ theme }) => css `
    height: ${theme.layoutFooterHeight};
  `}
`;
const Footer$1 = ({ children, className, }) => {
    const theme = useTheme();
    return (React.createElement(Container$j, { className: `${className} rtk-layout-footer`, theme: theme }, children));
};
Footer$1.displayName = 'LayoutFooter';

const StyledSider = styled.div `
  ${({ theme }) => css `
    @media (min-width: ${theme.mediaScreenSmall}) {
      width: ${theme.layoutSiderWidthSmall};
    }

    @media (min-width: ${theme.mediaScreenMedium}) {
      width: ${theme.layoutSiderWidthMedium};
    }

    @media (min-width: ${theme.mediaScreenLarge}) {
      width: ${theme.layoutSiderWidthLarge};
    }
  `}
`;
const Sider = ({ children, className, }) => {
    const theme = useTheme();
    return (React.createElement(StyledSider, { className: `${className} rtk-layout-sider`, theme: theme }, children));
};
Sider.displayName = 'LayoutSider';

const StyledLayout = styled.div `
  ${({ hasSider }) => css `
    display: flex;

    flex: auto;
    flex-direction: column;
    box-sizing: border-box;
    min-height: 0px;

    ${hasSider &&
    css `
      flex-direction: row;
    `}
  `}
`;
const Layout = ({ children, className, hasSider, }) => {
    return (React.createElement(StyledLayout, { className: `${className} rtk-layout`, hasSider: hasSider }, children));
};
Layout.displayName = 'Layout';
Layout.defaultProps = {
    hasSider: false,
};
Layout.Header = Header$2;
Layout.Content = Content$1;
Layout.Footer = Footer$1;
Layout.Sider = Sider;

const IconContainer = styled(motion.span) `
  position: absolute;
  top: calc(50% - 16px);

  display: flex;
  align-items: center;
`;
const FormItemIcon = ({ status, }) => {
    const theme = useTheme();
    const getIcon = React.useCallback(() => {
        switch (status) {
            case 'error': {
                return React.createElement(TimesCircle, { color: theme.colors.red });
            }
            case 'warning': {
                return React.createElement(ExclamationCircle, { color: theme.colors.orange });
            }
            case 'success': {
                return React.createElement(CheckCircle, { color: theme.colors.green });
            }
            case 'loading': {
                return React.createElement(Loading, { color: theme.colors.primary });
            }
        }
    }, [status, theme]);
    return (React.createElement(IconContainer, { key: "status-icon", initial: { opacity: 0, right: 0 }, animate: { opacity: 1, right: 5 }, exit: { opacity: 0, right: 0 }, transition: { duration: 0.1 } }, getIcon()));
};

const FormItemContainer = styled.div `
  margin-bottom: 16px;
`;
const Container$i = styled.div `
  position: relative;
`;
const StatusContainer = styled.div `
  margin-bottom: 8px;
`;
const StatusMessage = styled(Typography.Description) `
  ${({ theme, otherProps }) => otherProps.status === 'error' &&
    css `
      color: ${theme.colors.red};
    `}

  ${({ theme, otherProps }) => otherProps.status === 'warning' &&
    css `
      color: ${theme.colors.orange};
    `}

  ${({ theme, otherProps }) => otherProps.status === 'success' &&
    css `
      color: ${theme.colors.green};
    `}

  ${({ theme, otherProps }) => otherProps.status === 'loading' &&
    css `
      color: ${theme.colors.primary};
    `}
`;
const FormItem = ({ children, className, hasIcon, label, message, status, }) => {
    const theme = useTheme();
    return (React.createElement(FormItemContainer, { className: `${className} rtk-form-item` },
        React.createElement(Typography.Label, null, label),
        React.createElement(Container$i, null,
            React.createElement(FormItemContext.Provider, { value: {
                    status,
                    message,
                } }, children),
            React.createElement(AnimatePresence, null, status && hasIcon && React.createElement(FormItemIcon, { status: status })),
            React.createElement(StatusContainer, null,
                React.createElement(AnimatePresence, null, message && status && (React.createElement(motion.div, { key: "validate-message", style: { position: 'relative' }, initial: { opacity: 0, top: -5 }, animate: { opacity: 1, top: 0 }, exit: { opacity: 0, top: -5 }, transition: { duration: theme.animationTimeVeryFast } },
                    React.createElement(StatusMessage, { otherProps: { status }, theme: theme }, message))))))));
};
FormItem.defaultProps = {
    hasIcon: true,
};
FormItem.displayName = 'FormItem';

var markdownItContainer = function container_plugin(md, name, options) {

  // Second param may be useful if you decide
  // to increase minimal allowed marker length
  function validateDefault(params/*, markup*/) {
    return params.trim().split(' ', 2)[0] === name;
  }

  function renderDefault(tokens, idx, _options, env, slf) {

    // add a class to the opening tag
    if (tokens[idx].nesting === 1) {
      tokens[idx].attrJoin('class', name);
    }

    return slf.renderToken(tokens, idx, _options, env, slf);
  }

  options = options || {};

  var min_markers = 3,
      marker_str  = options.marker || ':',
      marker_char = marker_str.charCodeAt(0),
      marker_len  = marker_str.length,
      validate    = options.validate || validateDefault,
      render      = options.render || renderDefault;

  function container(state, startLine, endLine, silent) {
    var pos, nextLine, marker_count, markup, params, token,
        old_parent, old_line_max,
        auto_closed = false,
        start = state.bMarks[startLine] + state.tShift[startLine],
        max = state.eMarks[startLine];

    // Check out the first character quickly,
    // this should filter out most of non-containers
    //
    if (marker_char !== state.src.charCodeAt(start)) { return false; }

    // Check out the rest of the marker string
    //
    for (pos = start + 1; pos <= max; pos++) {
      if (marker_str[(pos - start) % marker_len] !== state.src[pos]) {
        break;
      }
    }

    marker_count = Math.floor((pos - start) / marker_len);
    if (marker_count < min_markers) { return false; }
    pos -= (pos - start) % marker_len;

    markup = state.src.slice(start, pos);
    params = state.src.slice(pos, max);
    if (!validate(params, markup)) { return false; }

    // Since start is found, we can report success here in validation mode
    //
    if (silent) { return true; }

    // Search for the end of the block
    //
    nextLine = startLine;

    for (;;) {
      nextLine++;
      if (nextLine >= endLine) {
        // unclosed block should be autoclosed by end of document.
        // also block seems to be autoclosed by end of parent
        break;
      }

      start = state.bMarks[nextLine] + state.tShift[nextLine];
      max = state.eMarks[nextLine];

      if (start < max && state.sCount[nextLine] < state.blkIndent) {
        // non-empty line with negative indent should stop the list:
        // - ```
        //  test
        break;
      }

      if (marker_char !== state.src.charCodeAt(start)) { continue; }

      if (state.sCount[nextLine] - state.blkIndent >= 4) {
        // closing fence should be indented less than 4 spaces
        continue;
      }

      for (pos = start + 1; pos <= max; pos++) {
        if (marker_str[(pos - start) % marker_len] !== state.src[pos]) {
          break;
        }
      }

      // closing code fence must be at least as long as the opening one
      if (Math.floor((pos - start) / marker_len) < marker_count) { continue; }

      // make sure tail has spaces only
      pos -= (pos - start) % marker_len;
      pos = state.skipSpaces(pos);

      if (pos < max) { continue; }

      // found!
      auto_closed = true;
      break;
    }

    old_parent = state.parentType;
    old_line_max = state.lineMax;
    state.parentType = 'container';

    // this will prevent lazy continuations from ever going past our end marker
    state.lineMax = nextLine;

    token        = state.push('container_' + name + '_open', 'div', 1);
    token.markup = markup;
    token.block  = true;
    token.info   = params;
    token.map    = [ startLine, nextLine ];

    state.md.block.tokenize(state, startLine + 1, nextLine);

    token        = state.push('container_' + name + '_close', 'div', -1);
    token.markup = state.src.slice(start, pos);
    token.block  = true;

    state.parentType = old_parent;
    state.lineMax = old_line_max;
    state.line = nextLine + (auto_closed ? 1 : 0);

    return true;
  }

  md.block.ruler.before('fence', 'container_' + name, container, {
    alt: [ 'paragraph', 'reference', 'blockquote', 'list' ]
  });
  md.renderer.rules['container_' + name + '_open'] = render;
  md.renderer.rules['container_' + name + '_close'] = render;
};

const Span = styled.span `
  h1 {
    ${h1Styles};
  }

  h2 {
    ${h2Styles};
  }

  h3 {
    ${h3Styles};
  }

  h4 {
    ${h4Styles};
  }

  h5 {
    ${h5Styles};
  }

  h6 {
    ${h6Styles};
  }

  p {
    ${bodyStyles};
  }

  code {
    color: ${({ theme }) => theme.colors.code};
    padding: 4px;
    border-radius: 4px;
    background: ${({ theme }) => theme.colors.tertiaryBackground};
  }

  mark {
    background: ${({ theme }) => rgba(theme.colors.yellow, 0.4)};
    padding: 2px;
    border-radius: 4px;
  }

  .warning {
    display: block;
    background: ${({ theme }) => rgba(theme.colors.yellow, 0.4)};
    border: 1px solid ${({ theme }) => theme.colors.yellow};
    border-radius: 4px;
    padding: 8px;
    margin: 16px 0;
    p {
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  .danger {
    display: block;
    background: ${({ theme }) => rgba(theme.colors.red, 0.4)};
    border: 1px solid ${({ theme }) => theme.colors.red};
    border-radius: 4px;
    padding: 8px;
    margin: 16px 0;
    p {
      margin-top: 0;
      margin-bottom: 0;
    }
  }
`;
const Markdown = ({ children }) => {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const md = require('markdown-it')()
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        .use(require('markdown-it-mark'))
        .use(markdownItContainer, 'danger')
        .use(markdownItContainer, 'warning');
    const theme = useTheme();
    return (React.createElement("div", { className: "markdown" }, React.Children.map(children, (child) => {
        if (typeof child === 'string') {
            return (React.createElement(Span, { theme: theme, dangerouslySetInnerHTML: { __html: md.render(child) } }));
        }
        else {
            return child;
        }
    })));
};

const ModalRoot = styled(motion.div) ``;
const ModalMask = styled(motion.div) `
  ${({ theme }) => css `
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1999;
    height: 100%;
    width: 100%;

    background: ${theme.modalMaskBackground};

    @media (max-width: ${theme.mediaScreenSmall}) {
      visibility: hidden;
    }
  `};
`;
const ModalWrapper = styled.div `
  ${({ theme }) => css `
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 2000;
    overflow: auto;

    text-align: center;

    @media (max-width: ${theme.mediaScreenSmall}) {
      overflow: hidden;
    }

    &::before {
      display: inline-block;
      width: 0;
      height: 100%;
      vertical-align: middle;
      content: '';
    }
  `};
`;
const ModalContainer = styled(motion.div) `
  ${({ theme }) => css `
    display: inline-block;
    vertical-align: middle;
    text-align: left;

    min-height: ${theme.modalMinHeight};
    min-width: ${theme.modalMinWidth};

    margin: 0 auto;

    outline: 0;

    @media (max-width: ${theme.mediaScreenSmall}) {
      height: 100%;
      width: 100%;

      min-width: 0;
    }
  `};
`;
const ModalBody = styled(motion.div) `
  ${({ theme }) => css `
    display: flex;
    flex-direction: column;
    background: ${theme.modalBackground};
    border: ${theme.modalBorder};
    border-color: ${theme.modalBorderColor};
    border-radius: ${theme.modalBorderRadius};

    box-shadow: ${theme.modalBoxShadow};

    outline: 0;

    @media (max-width: ${theme.mediaScreenSmall}) {
      height: 100%;

      border-radius: 0;
      box-shadow: none;
    }
  `};
`;
const ModalSentinel = styled.div `
  width: 0;
  height: 0;
  overflow: hidden;

  &:focus {
    outline: 0;
  }
`;

const Container$h = styled.div `
  ${({ theme }) => css `
    width: 100%;

    display: flex;
    align-items: center;
    margin-top: 24px;

    background: ${theme.modalHeaderBackground};
    color: ${theme.modalHeaderColor};
    padding: ${theme.modalHeaderPadding};

    border-top-right-radius: ${theme.modalBorderRadius};
    border-top-left-radius: ${theme.modalBorderRadius};

    font-size: 24px;
    font-weight: bold;
    box-sizing: border-box;
  `};
`;
const Title$1 = styled.div `
  flex: 1;
`;
const Close = styled.div `
  ${({ theme }) => css `
    display: flex;
    align-items: center;
    justify-content: flex-end;

    width: ${theme.modalHeaderHeight};
    cursor: pointer;

    transition: all ${theme.animationTimeFast}s;
    opacity: 0.5;

    &:hover,
    &:focus {
      opacity: 1;
      outline: 0;
    }

    &::-moz-focus-inner {
      border: none;
    }
  `};
`;
const Header$1 = ({ children, closable, closeIcon, onCancel, theme, }) => {
    return (React.createElement(Container$h, { theme: theme, className: "rtk-modal-header" },
        React.createElement(Title$1, null, children),
        closable && (React.createElement(Close, { onClick: onCancel, theme: theme, tabIndex: 0 }, closeIcon ? closeIcon : React.createElement(Icon.Times, null)))));
};
Header$1.displayName = 'ModalHeader';
Header$1.defaultProps = {
    closable: true,
};

const Content = styled.div `
  ${({ theme }) => css `
    padding: ${theme.modalContentPadding};
    overflow: auto;
    flex: 1;
  `};
`;

const Footer = styled.div `
  ${({ theme }) => css `
    width: 100%;
    height: ${theme.modalFooterHeight};

    display: flex;
    align-items: center;
    justify-content: flex-end;

    padding: ${theme.modalFooterPadding};
    box-sizing: border-box;

    border-bottom-right-radius: ${theme.modalBorderRadius};
    border-bottom-left-radius: ${theme.modalBorderRadius};
    background: ${theme.modalFooterBackground};
  `};
`;
const CancelButton = styled(Button) `
  margin-left: 16px;
`;
const DefaultFooter = ({ cancelButtonProps, cancelButtonText, okButtonProps, onCancel, okButtonText, onOk, }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, Object.assign({ onClick: onOk }, okButtonProps), okButtonText),
        React.createElement(CancelButton, Object.assign({ onClick: onCancel, ghost: true }, cancelButtonProps), cancelButtonText)));
};
DefaultFooter.displayName = 'DefaultModalFooter';
DefaultFooter.defaultProps = {
    okButtonText: 'Okay',
    cancelButtonText: 'Cancel',
};

var KEY_CODES;
(function (KEY_CODES) {
    KEY_CODES[KEY_CODES["ESC"] = 27] = "ESC";
    KEY_CODES[KEY_CODES["TAB"] = 9] = "TAB";
    KEY_CODES[KEY_CODES["ENTER"] = 13] = "ENTER";
})(KEY_CODES || (KEY_CODES = {}));
const Modal = ({ allowKeyboard, className, children, cancelButtonProps, cancelButtonText, closable, closeIcon, title, footer, okButtonProps, okButtonText, onOk, onCancel, visible, }) => {
    const previousActiveElement = React.useRef(null);
    const modalWrapper = React.useRef(null);
    const modalSentinelStart = React.useRef(null);
    const modalSentinelEnd = React.useRef(null);
    const modalMouseDown = React.useRef(false);
    const theme = useTheme();
    const checkFocus = React.useCallback(() => {
        if (modalWrapper.current == null ||
            modalSentinelStart.current == null ||
            !visible) {
            return;
        }
        if (!modalWrapper.current.contains(document.activeElement)) {
            modalSentinelStart.current.focus();
        }
    }, [modalSentinelStart, modalWrapper, visible]);
    // handle the ok click
    const handleOk = React.useCallback(() => {
        if (onOk) {
            onOk();
        }
    }, [onOk]);
    // handle closing the modal and calling onCancel
    const handleClose = React.useCallback(() => {
        if (onCancel) {
            onCancel();
        }
    }, [onCancel]);
    // handle closing the modal when the masked element is clicked
    const handleMaskClick = React.useCallback((e) => {
        if (e.target === e.currentTarget && !modalMouseDown.current) {
            handleClose();
        }
    }, [handleClose, modalMouseDown]);
    // handle the mouse up event on the masked element to prevent closing
    // when not intended
    const handleMouseUp = React.useCallback(() => {
        if (modalMouseDown.current) {
            // set timeout of 0 will defer the execution of the callback
            // until after the the onclick event is handled
            setTimeout(() => {
                modalMouseDown.current = false;
            }, 0);
        }
    }, [modalMouseDown]);
    const handleMouseDown = React.useCallback(() => {
        modalMouseDown.current = true;
    }, [modalMouseDown]);
    // handle keydown events for accessibility behaviours
    const handleKeyDown = React.useCallback((e) => {
        const activeElement = document.activeElement;
        if (!(modalSentinelEnd.current && modalSentinelStart.current)) {
            return;
        }
        switch (e.keyCode) {
            case KEY_CODES.ESC: {
                if (allowKeyboard) {
                    handleClose();
                }
                break;
            }
            case KEY_CODES.TAB: {
                if (e.shiftKey) {
                    if (activeElement === modalSentinelStart.current) {
                        modalSentinelEnd.current.focus();
                        break;
                    }
                }
                else if (activeElement === modalSentinelEnd.current) {
                    modalSentinelStart.current.focus();
                    break;
                }
                break;
            }
            case KEY_CODES.ENTER: {
                if (allowKeyboard) {
                    handleOk();
                }
                break;
            }
        }
    }, [handleOk, handleClose, modalSentinelStart, modalSentinelEnd, allowKeyboard]);
    // In order to support clicking the mask to close we need to stop click events on
    // the modal container from bubbling up.
    const handleWrapClick = React.useCallback((e) => {
        e.stopPropagation();
    }, []);
    // store which element was active before the modal opens
    React.useEffect(() => {
        previousActiveElement.current = document.activeElement;
        return () => previousActiveElement.current.focus();
    }, []);
    React.useEffect(() => {
        if (visible) {
            document.body.style.overflow = 'hidden';
            checkFocus();
        }
        else {
            document.body.style.overflow = '';
        }
    }, [visible, checkFocus]);
    React.useEffect(() => {
        return () => {
            // when a visible modal is abruptly unmounted (removed from DOM)
            // we should revert the overflow style as well
            document.body.style.overflow = '';
        };
    }, []);
    return (React.createElement(Portal, null,
        React.createElement(AnimatePresence, null, visible && (React.createElement(ModalRoot, { className: `${className} rtk-modal-root`, exit: { opacity: 0 }, onKeyDown: handleKeyDown, transition: { duration: theme.animationTimeVeryFast } },
            React.createElement(ModalMask, { className: 'rtk-modal-mask', key: "mask", theme: theme, initial: { opacity: 0 }, animate: { opacity: 1 }, transition: { duration: theme.animationTimeVeryFast } }),
            React.createElement(ModalWrapper, { className: 'rtk-modal-wrapper', role: "dialog", tabIndex: -1, ref: modalWrapper, onClick: handleMaskClick, onMouseUp: handleMouseUp, theme: theme },
                React.createElement(ModalContainer, { className: 'rtk-modal', role: "document", initial: { y: 24, opacity: 0 }, animate: { y: 0, opacity: 1 }, transition: { duration: theme.animationTimeVeryFast }, theme: theme },
                    React.createElement(ModalSentinel, { ref: modalSentinelStart, tabIndex: 0, "aria-hidden": "true" }),
                    React.createElement(ModalBody, { className: 'rtk-modal-body', onClick: handleWrapClick, onMouseDown: handleMouseDown, theme: theme },
                        React.createElement(Header$1, { closable: closable, closeIcon: closeIcon, onCancel: handleClose, theme: theme }, title),
                        React.createElement(Content, { theme: theme }, children),
                        React.createElement(Footer, { className: "rtk-modal-footer", theme: theme }, footer ? (footer) : (React.createElement(DefaultFooter, { cancelButtonProps: cancelButtonProps, cancelButtonText: cancelButtonText, okButtonProps: okButtonProps, okButtonText: okButtonText, onCancel: handleClose, onOk: handleOk, theme: theme })))),
                    React.createElement(ModalSentinel, { ref: modalSentinelEnd, tabIndex: 0, "aria-hidden": "true" }))))))));
};
Modal.displayName = 'Modal';
Modal.defaultProps = {
    allowKeyboard: true,
    visible: false,
    okButtonProps: {
        type: 'primary',
    },
    cancelButtonProps: {
        ghost: true,
    },
};

const MenuContext = React.createContext({});

const Container$g = styled.div `
  ${({ disabled, theme, isSelected }) => css `
    padding: ${theme.menuItemPadding};

    cursor: pointer;
    user-select: none;

    &:hover {
      .rtk-type-body {
        color: ${theme.menuItemHoverColor};
      }
      background: ${theme.menuItemHoverBackground};
    }

    ${isSelected &&
    css `
      .rtk-type-body {
        color: ${theme.menuItemHoverColor};
      }
    `}

    ${disabled &&
    css `
      cursor: default;
      pointer-events: none;
    `}
  `}
`;
const MenuItem = ({ className, children, disabled, itemKey, }) => {
    const theme = useTheme();
    const { onClick, selectedItem } = React.useContext(MenuContext);
    const handleClick = React.useCallback(() => {
        if (onClick && !disabled) {
            onClick(itemKey);
        }
    }, [itemKey, disabled, onClick]);
    return (React.createElement(Container$g, { className: `${className} rtk-menu-item`, key: itemKey, disabled: disabled, isSelected: selectedItem === itemKey, theme: theme, onClick: handleClick },
        React.createElement(Typography.Body, { disabled: disabled }, children)));
};
MenuItem.displayName = 'MenuItem';

const Container$f = styled.div `
  ${({}) => css `
    padding: 0px 16px;

    margin: 8px 0px 0px 0px;
  `}
`;
const MenuItemGroup = ({ className, children, title, }) => {
    return (React.createElement(Container$f, { className: `${className} rtk-menu-item-group` },
        React.createElement(Typography.Description, null, title),
        children));
};
MenuItemGroup.displayName = 'MenuItemGroup';

const Container$e = styled.div `
  padding: 8px 0px;
`;
const Menu = ({ className, children, defaultSelectedItem, onClick, }) => {
    const [selectedItem, setSelectedItem] = React.useState(defaultSelectedItem || '');
    const handleItemClick = React.useCallback((key) => {
        if (onClick) {
            onClick(key);
        }
        setSelectedItem(key);
    }, [onClick]);
    return (React.createElement(MenuContext.Provider, { value: {
            onClick: handleItemClick,
            selectedItem,
        } },
        React.createElement(Container$e, { className: `${className} rtk-menu` }, children)));
};
Menu.displayName = 'Menu';
Menu.Item = MenuItem;
Menu.ItemGroup = MenuItemGroup;

const Container$d = styled(motion.div) `
  min-height: ${({ theme }) => theme.notificationMinHeight};

  max-width: ${({ theme }) => theme.notificationMaxWidth};
  min-width: ${({ theme }) => theme.notificationMinWidth};
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: space-between;
  
  background: ${({ theme }) => theme.notificationBackground};
  border-left: 8px solid;

  border-radius: ${({ theme }) => theme.notificationBorderRadius};

  margin-bottom: 16px;
  
  ${({ notificationType }) => notificationType === 'error' &&
    css `
      border-left-color: ${({ theme }) => theme.colors.red};
    `}

  ${({ notificationType }) => notificationType === 'warning' &&
    css `
      border-left-color: ${({ theme }) => theme.colors.yellow};
    `}

  ${({ notificationType }) => notificationType === 'success' &&
    css `
      border-left-color: ${({ theme }) => theme.colors.green};
    `}

  ${({ notificationType }) => notificationType === 'info' &&
    css `
      border-left-color: ${({ theme }) => theme.colors.blue};
    `}
  
  ${({ notificationType }) => notificationType === 'default' &&
    css `
      border-left-color: ${({ theme }) => theme.colors.gray};
    `}

  box-shadow: ${({ theme }) => theme.notificationBoxBoxShadow};

  padding: 16px;
`;
const NotificationTextContainer$1 = styled.div `
  flex: 1;
  padding: 0 16px;
`;
const NotificationText$1 = styled(Typography.Body) `
  margin-top: 8px;
  text-align: left;
`;
const NotificationTitle$1 = ({ children }) => (React.createElement(Typography.Title, { level: 5 }, children));

const NotificationIcon = ({ notificationType, }) => {
    const theme = useTheme();
    switch (notificationType) {
        case 'error': {
            return React.createElement(ExclamationCircle, { size: "lg", color: theme.colors.red });
        }
        case 'warning': {
            return React.createElement(ExclamationCircle, { size: "lg", color: theme.colors.yellow });
        }
        case 'success': {
            return React.createElement(CheckCircle, { size: "lg", color: theme.colors.green });
        }
        case 'info': {
            return React.createElement(InfoCircle, { size: "lg", color: theme.colors.blue });
        }
        case 'default': {
            return React.createElement(InfoCircle, { size: "lg", color: theme.colors.gray });
        }
        default: {
            return null;
        }
    }
};

const Container$c = styled.div `
  cursor: pointer;
  align-self: flex-start;
`;
const CloseIcon$1 = ({ onClose, itemKey, }) => {
    const handleClose = React.useCallback(() => {
        if (onClose) {
            onClose(itemKey);
        }
    }, [itemKey, onClose]);
    return (React.createElement(Container$c, { onClick: handleClose },
        React.createElement(Typography.Body, null,
            React.createElement(Times, null))));
};

const Notification = ({ animate, allowClose, children, className, duration, itemKey, onClose, notificationType, title, }) => {
    const theme = useTheme();
    // Remove the notification
    const close = React.useCallback(() => {
        if (onClose) {
            onClose(itemKey);
        }
    }, [onClose, itemKey]);
    // when the notification mounts, set a timeout to remove it.
    React.useEffect(() => {
        if (duration) {
            window.setTimeout(() => {
                close();
            }, duration);
        }
        // eslint-disable-next-line
    }, []);
    // memoize the animation props
    const animationProps = React.useMemo(() => {
        if (animate) {
            return {
                positionTransition: {
                    type: 'tween',
                    duration: 0.2,
                },
                layout: true,
                initial: { opacity: 0, x: 50 },
                animate: {
                    opacity: 1,
                    x: 0,
                    transition: { type: 'tween', duration: 0.2 },
                },
                exit: { opacity: 0, transition: { duration: 0.2 } },
            };
        }
        return {};
    }, [animate]);
    return (React.createElement(Container$d, Object.assign({ className: `${className} rtk-notification`, theme: theme, notificationType: notificationType }, animationProps),
        React.createElement(NotificationIcon, { notificationType: notificationType }),
        React.createElement(NotificationTextContainer$1, null,
            React.createElement(NotificationTitle$1, null, title),
            React.createElement(NotificationText$1, null, children)),
        allowClose && React.createElement(CloseIcon$1, { onClose: onClose, itemKey: itemKey })));
};
Notification.defaultProps = {
    allowClose: true,
};
Notification.displayName = 'Notification';

const Container$b = styled(motion.div) `
  min-height: ${({ theme }) => theme.notificationBoxMinHeight};

  max-width: ${({ theme }) => theme.notificationBoxMaxWidth};
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: space-between;
  
  margin-bottom: 16px;

  ${({ notificationType }) => notificationType === 'error' &&
    css `
      background: ${({ theme }) => theme.notificationBoxErrorBackground};
    `}

  ${({ notificationType }) => notificationType === 'warning' &&
    css `
      background: ${({ theme }) => theme.notificationBoxWarningBackground};
    `}

  ${({ notificationType }) => notificationType === 'success' &&
    css `
      background: ${({ theme }) => theme.notificationBoxSuccessBackground};
    `}

  ${({ notificationType }) => notificationType === 'info' &&
    css `
      background: ${({ theme }) => theme.notificationBoxInfoBackground};
    `}
  
  ${({ notificationType }) => notificationType === 'default' &&
    css `
      background: ${({ theme }) => theme.notificationBoxDefaultBackground};
    `}

  border-radius: ${({ theme }) => theme.notificationBoxBorderRadius};
  box-shadow: ${({ theme }) => theme.notificationBoxBoxShadow};

  padding: ${({ theme }) => theme.notificationBoxPadding};
`;
const NotificationTextContainer = styled.div `
  flex: 1;
  padding: 0 24px;
`;
const NotificationText = styled(Typography.Body) `
  text-align: left;
  color: ${({ theme }) => theme.notificationBoxColor};
`;
const StyledTitle = styled(Typography.Title) `
  color: ${({ theme }) => theme.notificationBoxColor};
`;
const NotificationTitle = ({ children }) => (React.createElement(StyledTitle, { level: 5 }, children));

const Container$a = styled.div `
  padding: 4px;

  cursor: pointer;
`;
const CloseIcon = ({ onClose }) => {
    const theme = useTheme();
    const handleClose = React.useCallback(() => {
        if (onClose) {
            onClose();
        }
    }, [onClose]);
    return (React.createElement(Container$a, { onClick: handleClose },
        React.createElement(Times, { color: theme.notificationBoxColor })));
};

const NotificationBox = ({ allowClose, animate, children, className, onClose, notificationType, itemKey, duration, title, }) => {
    const theme = useTheme();
    // Remove the notification
    const close = React.useCallback(() => {
        if (onClose) {
            onClose(itemKey);
        }
    }, [onClose, itemKey]);
    // when the notification mounts, set a timeout to remove it.
    React.useEffect(() => {
        if (duration) {
            window.setTimeout(() => {
                close();
            }, duration);
        }
        // eslint-disable-next-line
    }, []);
    // memoize the animation props
    const animationProps = React.useMemo(() => {
        if (animate) {
            return {
                positionTransition: {
                    type: 'tween',
                    duration: 0.2,
                },
                layout: true,
                initial: { opacity: 0, x: 50 },
                animate: {
                    opacity: 1,
                    x: 0,
                    transition: { type: 'tween', duration: 0.2 },
                },
                exit: { opacity: 0, transition: { duration: 0.2 } },
            };
        }
        return {};
    }, [animate]);
    return (React.createElement(Container$b, Object.assign({ className: `${className} rtk-validation-notification`, theme: theme, notificationType: notificationType }, animationProps),
        React.createElement(NotificationIcon, { notificationType: notificationType }),
        React.createElement(NotificationTextContainer, null,
            React.createElement(NotificationTitle, null, title),
            React.createElement(NotificationText, null, children)),
        allowClose && React.createElement(CloseIcon, { onClose: close })));
};
NotificationBox.defaultProps = {
    allowClose: true,
};
NotificationBox.displayName = 'NotificationBox';

const Container$9 = styled.div ``;
const NotificationBin = ({ children, className, duration, notifications, notificationComponent, onRemove, }) => {
    const NotificationComponent = notificationComponent === 'box' ? NotificationBox : Notification;
    return (React.createElement(Container$9, { className: `${className} rtk-notification-bin` },
        React.createElement(AnimatePresence, { initial: false }, notifications.map((_a) => {
            var { itemKey, children } = _a, props = __rest(_a, ["itemKey", "children"]);
            return (React.createElement(NotificationComponent, Object.assign({ duration: duration, key: itemKey, itemKey: itemKey, onClose: onRemove, animate: true }, props), children));
        })),
        children));
};
NotificationBin.defaultProps = {
    duration: 5000,
    notificationComponent: 'default',
};
NotificationBin.displayName = 'NotificationBin';

const Container$8 = styled.div `
  position: relative;
  background: ${({ theme }) => theme.panelBackground};
  border: ${({ theme }) => theme.panelBorder};
  border-color: ${({ theme }) => theme.panelBorderColor};
  border-radius: ${({ theme }) => theme.panelBorderRadius};
  padding: ${({ theme }) => theme.panelPadding};
  margin: ${({ theme, hasMargin }) => (hasMargin ? theme.panelMargin : 0)};
  transition: all ${({ theme }) => theme.animationTimeFast}s;

  box-sizing: border-box;

  ${({ onClick, theme }) => onClick &&
    css `
      &:hover {
        cursor: pointer;
        box-shadow: ${theme.panelHoverBoxShadow};
      }

      &:active {
        box-shadow: ${theme.panelActiveBoxShadow};
      }
    `}

  ${({ hasTitle, theme }) => hasTitle &&
    css `
      border: ${theme.panelWithTitleBorder};
      border-color: ${theme.panelWithTitleBorderColor};
    `}
`;
const Title = styled(Typography.Title) `
  position: absolute;
  background: inherit;

  ${({ level }) => level === 3 &&
    css `
      top: -15px;
    `}

  ${({ level }) => level === 5 &&
    css `
      top: -10px;
    `}
  
  left: 8px;
  border-radius: ${({ theme }) => theme.panelBorderRadius};

  padding: 4px 8px;
`;
const Panel = ({ children, className, hasMargin, onClick, title, titleLevel, }) => {
    const theme = useTheme();
    return (React.createElement(Container$8, { className: `${className} rtk-panel`, hasMargin: hasMargin, onClick: onClick, theme: theme, hasTitle: !(title == null) },
        title && (React.createElement(Title, { theme: theme, level: titleLevel }, title)),
        children));
};
Panel.defaultProps = {
    hasMargin: true,
    titleLevel: 3,
};
Panel.displayName = 'Panel';

const RadioContext = React.createContext({});

const Container$7 = styled.div `
  ${({ disabled }) => disabled &&
    css `
      pointer-events: none;
      opacity: 0.6;
    `}
`;
const StyledLabel = styled.label `
  position: relative;
  display: inline-block;

  line-height: ${({ theme }) => theme.radioItemLineHeight};
  margin: ${({ theme }) => theme.radioItemMargin};

  font-family: 'Lato', sans-serif;

  input {
    display: none;
  }

  span {
    font-size: ${({ theme }) => theme.radioItemFontSize};
    color: ${({ theme }) => theme.radioItemFontColor};
    transition: all ${({ theme }) => theme.animationTimeVeryFast}s ease-in-out;
    padding-left: 32px;

    &::before {
      content: '';

      position: absolute;
      display: block;
      top: 0;
      left: 0;

      height: 16px;
      width: 16px;
      border: ${({ theme }) => theme.radioItemBorder};
      box-sizing: border-box;

      transition: all ${({ theme }) => theme.animationTimeVeryFast}s ease-in-out;

      border-radius: 50%;
    }

    &::after {
      content: '';

      position: absolute;
      display: block;
      top: 5px;
      left: 5px;

      height: 6px;
      width: 6px;
      background: ${({ theme }) => theme.radioItemCheckedMiddleBackground};

      transition: all ${({ theme }) => theme.animationTimeVeryFast}s ease-in-out;

      border-radius: 50%;

      visibility: hidden;
    }
  }

  input[type='radio']:hover + span {
    color: ${({ theme }) => theme.radioItemHoverColor};

    &::before {
      border: ${({ theme }) => theme.radioItemHoverBorder};
    }
  }

  input[type='radio']:checked + span {
    &::before {
      background: ${({ theme }) => theme.radioItemCheckedBackground};
      border-color: ${({ theme }) => theme.radioItemCheckedBorderColor};
    }

    &::after {
      visibility: visible;
    }
  }
`;
const RadioItem = ({ children, disabled, itemKey, }) => {
    const { name, onSelect } = React.useContext(RadioContext);
    const theme = useTheme();
    const handleClick = React.useCallback(() => {
        if (onSelect) {
            onSelect(itemKey);
        }
    }, [onSelect, itemKey]);
    return (React.createElement(Container$7, { disabled: disabled },
        React.createElement(StyledLabel, { theme: theme },
            React.createElement("input", { type: "radio", name: name, onClick: handleClick }),
            React.createElement("span", null, children))));
};
RadioItem.displayName = 'RadioItem';

const Container$6 = styled.div ``;
const Radio = ({ children, className, name, onSelect, }) => {
    return (React.createElement(Container$6, { className: `${className} rtk-radio` },
        React.createElement(RadioContext.Provider, { value: {
                name,
                onSelect,
            } }, children)));
};
Radio.Item = RadioItem;
Radio.displayName = 'Radio';

// defines the list of styles from react-select that are overriden
const getCustomStyles = (theme) => ({
    control: (provided, state) => {
        const defaultStyles = Object.assign(Object.assign({}, provided), { borderWidth: '1px', borderStyle: 'solid', borderColor: theme.selectControlBorderColor, background: theme.selectControlBackground, minHeight: theme.selectControlMinHeight });
        if (state.isFocused) {
            return Object.assign(Object.assign({}, defaultStyles), { borderColor: theme.selectControlHoverBorderColor, boxShadow: 'none' });
        }
        if (state.isDisabled) {
            return Object.assign(Object.assign({}, defaultStyles), { background: theme.selectControlDisabledBackground, opacity: 0.8 });
        }
        return Object.assign({}, defaultStyles);
    },
    option: (provided, state) => {
        const defaultStyles = {
            fontSize: '14px',
            fontFamily: 'Lato',
            color: theme.selectOptionColor,
        };
        if (state.isSelected) {
            return Object.assign(Object.assign(Object.assign({}, provided), defaultStyles), { background: theme.selectOptionSelectedBackground, color: theme.selectOptionSelectedColor, fontWeight: 'bold' });
        }
        else if (state.isFocused) {
            return Object.assign(Object.assign(Object.assign({}, provided), defaultStyles), { backgroundColor: theme.selectOptionFocusedBackground });
        }
        return Object.assign(Object.assign({}, provided), defaultStyles);
    },
    menu: (provided) => {
        return Object.assign(Object.assign({}, provided), { background: theme.selectMenuBackground });
    },
    multiValueLabel: (provided) => {
        return Object.assign(Object.assign({}, provided), { color: theme.selectMultiValueLabelColor });
    },
    multiValue: (provided) => {
        return Object.assign(Object.assign({}, provided), { background: theme.selectMultiValueBackground });
    },
    singleValue: (provided) => {
        return Object.assign(Object.assign({}, provided), { color: theme.selectSingleValueColor, fontWeight: 'bold' });
    },
});
// some of the styles couldn't be overriden by the styles object
const Container$5 = styled.div `
  font-family: 'Lato';
  font-size: 14px;

  .rtk__control:hover {
    border-color: ${({ theme }) => theme.selectControlHoverBorderColor};
  }

  .rtk__input input {
    font-family: inherit;
  }

  .rtk__multi-value__remove:hover {
    cursor: pointer;
    background: ${({ theme }) => theme.selectMultiValueRemoveHoverBackground};
  }

  .rtk__indicator-separator {
    display: none;
  }
`;
const SelectIcon = styled.span `
  padding: 8px;
`;
const Select = ({ className, selectProps, }) => {
    const { classNamePrefix, // eslint-disable-line @typescript-eslint/no-unused-vars,
    components } = selectProps, restOfSelectProps = __rest(selectProps, ["classNamePrefix", "components"]);
    const theme = useTheme();
    const styles = React.useMemo(() => getCustomStyles(theme), [theme]);
    return (React.createElement(Container$5, { className: `${className} rtk-select`, theme: theme },
        React.createElement(ReactSelect, Object.assign({ classNamePrefix: "rtk", styles: styles, components: Object.assign(Object.assign({}, components), { DropdownIndicator: () => (React.createElement(SelectIcon, null,
                    React.createElement(CaretDown, { color: theme.colors.body }))), ClearIndicator: (props) => {
                    return (React.createElement(SelectIcon, { onClick: props.clearValue },
                        React.createElement(Times, { color: theme.colors.body })));
                }, MultiValueRemove: (props) => {
                    return (React.createElement("span", Object.assign({}, props.innerProps),
                        React.createElement(Times, { color: theme.colors.tag })));
                } }) }, restOfSelectProps))));
};
Select.displayName = 'Select';

const StyledCell$1 = styled.div `
  ${({ theme, justify, header }) => css `
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: ${justify || 'flex-start'};

    padding: ${theme.tableBodyCellPadding};

    ${header &&
    css `
      padding: ${theme.tableHeadCellPadding};
    `}
  `}
`;
const Cell = ({ className, children, justify, onClick, }) => {
    const theme = useTheme();
    const handleClick = React.useCallback((e) => {
        if (onClick) {
            onClick(e);
        }
    }, [onClick]);
    return (React.createElement(StyledCell$1, { className: className, onClick: handleClick, theme: theme, justify: justify }, children));
};

const getSortState = (currentState) => {
    switch (currentState) {
        case 'none':
            return 'asc';
        case 'asc':
            return 'dsc';
        case 'dsc':
            return 'none';
        default:
            return 'none';
    }
};
const StyledCell = styled(Cell) `
  ${({ theme, sortable }) => css `
    transition: background ${theme.animationTimeFast}s ease-in-out;

    ${sortable &&
    css `
      &:hover {
        cursor: pointer;
        background: ${theme.colors.hoverBackground};
      }
    `}
  `}
`;
const StyledSubtitle = styled(Typography.Subtitle) `
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.tableHeadFontColor};
  font-size: ${({ theme }) => theme.tableHeadFontSize};
`;
const SubtitleContent = styled.span `
  ${({ sortable }) => css `
    margin-right: ${sortable ? '8px' : 0};
  `}
`;
const HeaderCell = (props) => {
    const { column, header, onClick, sortedColumn, theme } = props;
    const [sortState, setSortState] = React.useState('none');
    const handleClick = React.useCallback(() => {
        if (column.sortable) {
            const newSortState = getSortState(sortState);
            onClick(column.key, newSortState);
            setSortState(newSortState);
        }
    }, [onClick, column, sortState]);
    // reset the sort state to remove the styles when the sorted column changes
    React.useEffect(() => {
        if (sortedColumn !== column.key) {
            setSortState('none');
        }
    }, [column.key, sortedColumn]);
    return (React.createElement(StyledCell, { sortable: column.sortable, onClick: handleClick, justify: column.justify, header: header, theme: theme },
        React.createElement(StyledSubtitle, null,
            React.createElement(SubtitleContent, { sortable: column.sortable }, column.title),
            column.sortable && React.createElement(Icon.Sort, { state: sortState }))));
};

const TH = styled.th `
  ${({ theme, width }) => css `
    margin: 0;
    border-bottom: ${theme.tableHeadBorder};
    border-bottom-color: ${theme.tableHeadBorderColor};
    width: ${width ? `${width}%` : 'auto'};
  `}
`;
const Header = (props) => {
    const { columns, onSort, sortedColumn, showHeader } = props;
    const theme = useTheme();
    if (!showHeader) {
        return null;
    }
    return (React.createElement("thead", null,
        React.createElement("tr", null, columns.map((col) => (React.createElement(TH, { key: col.key, theme: theme, width: col.width },
            React.createElement(HeaderCell, { header: true, column: col, onClick: onSort, sortedColumn: sortedColumn, theme: theme })))))));
};
Header.displayName = 'TableHead';

const TD = styled.td `
  ${({ theme }) => css `
    border-bottom: ${theme.tableBodyRowBorder};
    border-color: ${theme.tableBodyRowBorderColor};
  `}
`;
const TR = styled.tr `
  ${({ theme, selected }) => css `
    cursor: default;

    &:hover {
      ${!selected &&
    css `
        background: ${theme.colors.hoverBackground};
      `}
    }

    ${selected &&
    css `
      background: ${theme.colors.quaternaryBackground};
    `};

    transition: background ${theme.animationTimeVeryFast}s ease-in-out;
  `}
`;
const BodyText = styled(Typography.Body) `
  color: ${({ theme, selected }) => selected ? theme.colors.primary : theme.tableBodyFontColor};
  font-size: ${({ theme }) => theme.tableBodyFontSize};
  font-weight: ${({ selected }) => (selected ? 'bold' : 'normal')};
`;
const EmptyContentContainer = styled.div `
  ${({ theme }) => css `
    height: ${theme.tableEmptyContainerHeight};

    display: flex;
    align-items: center;
    justify-content: center;
  `}
`;
const Body = (props) => {
    const { columns, data, dataUniqueKey, emptyComponent, onRow, selectedRowKey, } = props;
    const theme = useTheme();
    const handleClick = React.useCallback((e, d) => {
        if (onRow && onRow.onClick) {
            onRow.onClick(e, d);
        }
    }, [onRow]);
    const renderDataIndex = React.useCallback((column, data) => {
        if (column.dataIndex == null) {
            // eslint-disable-next-line no-console
            console.warn(`You must supply a dataIndex or render function for column: ${column.key}`);
            return null;
        }
        else {
            return data[column.dataIndex];
        }
    }, []);
    const renderBodyCell = React.useCallback(() => {
        if (data.length === 0) {
            return (React.createElement("tr", null,
                React.createElement(TD, { colSpan: columns.length },
                    React.createElement(EmptyContentContainer, { theme: theme },
                        React.createElement(BodyText, null, emptyComponent == null ? 'No Data' : emptyComponent)))));
        }
        return data.map((d, index) => (React.createElement(TR, { theme: theme, key: index, selected: selectedRowKey ? selectedRowKey === d[dataUniqueKey] : false, onClick: (e) => handleClick(e, d) }, columns.map((c) => {
            const Renderer = c.render;
            return (React.createElement(TD, { key: c.key, theme: theme },
                React.createElement(Cell, { justify: c.justify },
                    React.createElement(BodyText, { selected: selectedRowKey ? selectedRowKey === d[dataUniqueKey] : false }, Renderer == null ? (renderDataIndex(c, d)) : (React.createElement(Renderer, { record: d }))))));
        }))));
    }, [
        data,
        dataUniqueKey,
        columns,
        emptyComponent,
        renderDataIndex,
        theme,
        selectedRowKey,
        handleClick,
    ]);
    return React.createElement("tbody", null, renderBodyCell());
};
Body.displayName = 'TableBody';

const LoadingContainer = styled(motion.div) `
  position: absolute;
  top: 0;
  left: 0;

  height: 100%;
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
`;
const LoadingMask = styled.div `
  ${({ theme }) => css `
    height: 100%;
    width: 100%;

    opacity: 0.8;
    background: ${theme.colors.primaryBackground};
  `}
`;
const LoadingText = styled(Typography.Body) `
  position: absolute;
`;
const LoadingIcon = styled(Icon.Loading) `
  margin-right: 8px;
`;
const TableLoading = ({ loadingComponent, }) => {
    const theme = useTheme();
    return (React.createElement(LoadingContainer, { variants: {
            loading: {
                opacity: 1,
                transition: { duration: theme.animationTimeFast },
            },
            complete: {
                opacity: 0,
                transition: { duration: theme.animationTimeFast },
            },
        }, initial: 'complete', animate: 'loading', exit: 'complete' },
        React.createElement(LoadingMask, { theme: theme }),
        React.createElement(LoadingText, { theme: theme },
            React.createElement(LoadingIcon, null),
            loadingComponent == null ? 'Loading Data...' : loadingComponent)));
};

const Container$4 = styled.div `
  position: relative;
`;
const TableContainer = styled.table `
  width: 100%;
  border-spacing: 0;
`;
const Table = (props) => {
    const [sortedColumn, setSortedColumn] = React.useState(null);
    const { className, columns, data, dataUniqueKey, emptyComponent, loading, loadingComponent, onRow, onSort, selectedRowKey, showHeader, } = props;
    const handleSort = React.useCallback((itemKey, state) => {
        if (onSort) {
            onSort(itemKey, state);
            setSortedColumn(itemKey);
        }
    }, [onSort]);
    return (React.createElement(Container$4, { className: `${className} rtk-table` },
        React.createElement(AnimatePresence, null, loading && React.createElement(TableLoading, { loadingComponent: loadingComponent })),
        React.createElement(TableContainer, null,
            React.createElement(Header, { columns: columns, onSort: handleSort, sortedColumn: sortedColumn, showHeader: showHeader }),
            React.createElement(Body, { columns: columns, data: data, dataUniqueKey: dataUniqueKey, emptyComponent: emptyComponent, onRow: onRow, selectedRowKey: selectedRowKey }))));
};
Table.defaultProps = {
    showHeader: true,
};
Table.displayName = 'Table';

const TabsContext = React.createContext({});

const Container$3 = styled.div `
  ${({ theme, isSelected, }) => css `
    cursor: pointer;
    box-sizing: border-box;
    user-select: none;

    padding: ${theme.tabsItemPadding};

    transition: opacity ${theme.animationTimeVeryFast}s ease-in-out;

    opacity: 0.7;

    ${isSelected &&
    css `
      opacity: 1;
    `}

    &:hover {
      opacity: 1;
    }
  `}
`;
const TabBody = styled(Typography.Body) `
  ${({ theme }) => css `
    color: ${theme.tabsItemColor};
  `}
`;
const TabsItem = ({ className, itemKey, title, }) => {
    const tabItemRef = React.useRef(null);
    const theme = useTheme();
    const { defaultSelectedItem, onClick, setActiveItem, selectedItem, } = React.useContext(TabsContext);
    const handleClick = React.useCallback((e) => {
        if (onClick) {
            onClick(itemKey, e);
        }
    }, [onClick, itemKey]);
    const setSelectedItem = React.useCallback(() => {
        if (tabItemRef.current == null) {
            return;
        }
        if (setActiveItem) {
            setActiveItem({
                itemKey,
                width: tabItemRef.current.offsetWidth,
                x: tabItemRef.current.offsetLeft,
            });
        }
    }, [setActiveItem, tabItemRef, itemKey]);
    // handles setting the default selected item
    React.useEffect(() => {
        if (defaultSelectedItem === itemKey && tabItemRef.current !== null) {
            setSelectedItem();
        }
        // we only need to run on initial mount
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // handles when the selected item changes
    React.useEffect(() => {
        if (selectedItem === itemKey && tabItemRef.current !== null) {
            setSelectedItem();
        }
        // we only care when the selected item has changed
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedItem]);
    return (React.createElement(Container$3, { className: `${className} rtk-tabs-item`, onClick: handleClick, isSelected: selectedItem === itemKey },
        React.createElement(TabBody, { theme: theme, ref: tabItemRef }, title)));
};
TabsItem.displayName = 'TabsItem';

const Container$2 = styled.div `
  position: absolute;
`;
const TabsContainer = styled.div `
  ${({ placement }) => css `
    ${placement === 'top' &&
    css `
      display: flex;
      align-items: center;
    `}
  `}
`;
const Inkbar = styled.div `
  ${({ theme }) => css `
    position: relative;
    background: ${theme.tabsInkbarColor};
    height: ${theme.tabsInkbarThickness};

    transition: all ${theme.animationTimeVeryFast}s ease-in-out;
  `}
`;
const Tabs = ({ selectedItem, className, children, defaultSelectedItem, onTabClick, placement, }) => {
    const [activeItem, setActiveItem] = React.useState();
    const theme = useTheme();
    const handleTabClick = React.useCallback((key) => {
        // prevents onTabClick from being called when the tab item is already selected
        if (activeItem && activeItem.itemKey !== key && onTabClick) {
            onTabClick(key);
        }
    }, [onTabClick, activeItem]);
    return (React.createElement(TabsContext.Provider, { value: {
            defaultSelectedItem,
            selectedItem,
            setActiveItem,
            onClick: handleTabClick,
        } },
        React.createElement(Container$2, { className: `${className} rtk-tabs` },
            React.createElement(TabsContainer, { className: "rtk-tabs-container", placement: placement, theme: theme }, children),
            React.createElement(Inkbar, { theme: theme, style: {
                    visibility: activeItem == null ? 'hidden' : 'visible',
                    width: activeItem == null ? 'unset' : activeItem.width,
                    left: activeItem == null ? 'unset' : activeItem.x,
                } }))));
};
Tabs.Item = TabsItem;
Tabs.displayName = 'Tabs';
Tabs.defaultProps = {
    placement: 'top',
};

const ToggleCheck = styled(Check) `
  position: absolute;

  top: 2px;
  left: 4px;
`;
const ToggleLoadingOn = styled(Loading) `
  position: absolute;

  top: 2px;
  left: 4px;
`;
const ToggleLoadingOff = styled(Loading) `
  position: absolute;

  top: 2px;
  left: 17px;
`;
const ToggleIcon = ({ isOn, isLoading, theme }) => {
    if (isOn) {
        if (isLoading) {
            return React.createElement(ToggleLoadingOn, { color: theme.toggleOnIconColor, size: "xs" });
        }
        else {
            return React.createElement(ToggleCheck, { color: theme.toggleOnIconColor, size: "xs" });
        }
    }
    else {
        if (isLoading) {
            return React.createElement(ToggleLoadingOff, { color: theme.toggleOnIconColor, size: "xs" });
        }
        else {
            return null;
        }
    }
};

const Container$1 = styled.div `
  position: relative;
  height: ${({ theme }) => theme.toggleHeight};
  width: ${({ theme }) => theme.toggleWidth};
  min-width: ${({ theme }) => theme.toggleWidth};

  background: ${({ theme, isOn }) => isOn ? theme.toggleOnBackground : theme.toggleOffBackground};
  border-radius: ${({ theme }) => theme.toggleBorderRadius};
  cursor: pointer;

  ${({ disabled, theme }) => disabled &&
    css `
      pointer-events: none;
      background: ${theme.toggleDisabledBackground};
    `}
`;
const ToggleCircleContainer = styled(motion.div) `
  position: absolute;
  top: ${({ theme }) => theme.toggleCircleTop};
`;
const ToggleCircle = styled.div `
  background: ${({ theme }) => theme.toggleCircleBackground};

  height: ${({ theme }) => theme.toggleCircleHeight};
  width: ${({ theme }) => theme.toggleCircleWidth};

  border-radius: 50%;
`;
const Toggle = ({ className, disabled, isLoading, onClick, isOn, }) => {
    const theme = useTheme();
    return (React.createElement(Container$1, { className: `${className} rtk-toggle`, theme: theme, onClick: onClick, isOn: isOn || false, disabled: disabled || isLoading },
        React.createElement(ToggleCircleContainer, { theme: theme, initial: 'off', variants: {
                on: {
                    x: 18,
                },
                off: {
                    x: 2,
                },
            }, animate: isOn ? 'on' : 'off', transition: { duration: theme.animationTimeVeryFast, type: 'tween' } },
            React.createElement(ToggleCircle, { theme: theme })),
        React.createElement(ToggleIcon, { theme: theme, isLoading: isLoading, isOn: isOn })));
};
Toggle.displayName = 'Toggle';

const placements = {
    topLeft: ['tl', 'bl'],
    top: ['tc', 'bc'],
    topRight: ['tr', 'br'],
    rightTop: ['tr', 'tl'],
    right: ['cr', 'cl'],
    rightBottom: ['br', 'bl'],
    bottomRight: ['br', 'tr'],
    bottom: ['bc', 'tc'],
    bottomLeft: ['bl', 'tl'],
    leftTop: ['tl', 'tr'],
    left: ['cl', 'cr'],
    leftBottom: ['bl', 'br'],
};

const TooltipContent = styled.div `
  ${({ placement, gap, theme }) => css `
    position: relative;

    ${(placement === 'top' ||
    placement === 'topLeft' ||
    placement === 'topRight') &&
    css `
        padding-bottom: ${`calc(${theme.tooltipArrowSize} / 2)`};
        margin-bottom: ${gap == null ? theme.tooltipMargin : gap};
      `}

    ${(placement === 'right' ||
    placement === 'rightTop' ||
    placement === 'rightBottom') &&
    css `
        padding-left: ${`calc(${theme.tooltipArrowSize} / 2)`};
        margin-left: ${gap == null ? theme.tooltipMargin : gap};
      `}

    ${(placement === 'bottom' ||
    placement === 'bottomRight' ||
    placement === 'bottomLeft') &&
    css `
        padding-top: ${`calc(${theme.tooltipArrowSize} / 2)`};
        margin-top: ${gap == null ? theme.tooltipMargin : gap};
      `}

    ${(placement === 'left' ||
    placement === 'leftTop' ||
    placement === 'leftBottom') &&
    css `
        padding-right: ${`calc(${theme.tooltipArrowSize} / 2)`};
        margin-right: ${gap == null ? theme.tooltipMargin : gap};
      `}
  `}
`;
const OverlayContainer = styled.div `
  ${({ theme }) => css `
    background: ${theme.colors.primaryBackground};
    box-shadow: ${theme.tooltipBoxShadow};
    border-radius: ${theme.tooltipBorderRadius};
    border: ${theme.tooltipBorder};
    border-color: ${theme.tooltipBorderColor};
  `}
`;
const Arrow = styled.div `
  ${({ placement, theme }) => css `
    position: absolute;
    width: ${theme.tooltipArrowSize};
    height: ${theme.tooltipArrowSize};
    background: ${theme.colors.primaryBackground};
    transform: rotate(45deg);

    /* Arrow pointing down */
    ${(placement === 'top' ||
    placement === 'topLeft' ||
    placement === 'topRight') &&
    css `
        border-right: ${theme.tooltipBorder};
        border-bottom: ${theme.tooltipBorder};
        border-color: ${theme.tooltipBorderColor};
      `}

    /* Arrow pointing left */
    ${(placement === 'right' ||
    placement === 'rightTop' ||
    placement === 'rightBottom') &&
    css `
        border-bottom: ${theme.tooltipBorder};
        border-left: ${theme.tooltipBorder};
        border-color: ${theme.tooltipBorderColor};
      `}

    /* Arrow pointing up */
    ${(placement === 'bottom' ||
    placement === 'bottomRight' ||
    placement === 'bottomLeft') &&
    css `
        border-top: ${theme.tooltipBorder};
        border-left: ${theme.tooltipBorder};
        border-color: ${theme.tooltipBorderColor};
      `}

    /* Arrow pointing right */
    ${(placement === 'left' ||
    placement === 'leftTop' ||
    placement === 'leftBottom') &&
    css `
        border-top: ${theme.tooltipBorder};
        border-right: ${theme.tooltipBorder};
        border-color: ${theme.tooltipBorderColor};
      `}

    /* top arrow placements */
    ${placement === 'top' &&
    css `
        bottom: 0px;
        left: calc(50% - 8px);
      `}

    ${placement === 'topLeft' &&
    css `
        bottom: 0px;
        left: 20%;
      `}

    ${placement === 'topRight' &&
    css `
        bottom: 0px;
        right: 20%;
      `}

    /* right arrow placements */
    ${placement === 'rightTop' &&
    css `
        top: 10%;
        left: 0px;
      `}

    ${placement === 'right' &&
    css `
        top: calc(50% - 8px);
        left: 0px;
      `}

    ${placement === 'rightBottom' &&
    css `
        bottom: 10%;
        left: 0px;
      `}

    /* bottom arrow placements */
    ${placement === 'bottomRight' &&
    css `
        top: 0px;
        right: 20%;
      `}

    ${placement === 'bottom' &&
    css `
        top: 0px;
        left: calc(50% - 8px);
      `}

    ${placement === 'bottomLeft' &&
    css `
        top: 0px;
        left: 20%;
      `}

    /* left arrow placements */
    ${placement === 'leftBottom' &&
    css `
        bottom: 10%;
        right: 0px;
      `}

    ${placement === 'left' &&
    css `
        top: calc(50% - 8px);
        right: 0px;
      `}

    ${placement === 'leftTop' &&
    css `
        top: 10%;
        right: 0px;
      `}
  `}
`;
const TooltipContainer = ({ children, gap, hideArrow, placement, }) => {
    const theme = useTheme();
    return (React.createElement(TooltipContent, { placement: placement, gap: gap, theme: theme },
        !hideArrow && React.createElement(Arrow, { placement: placement, theme: theme }),
        React.createElement(OverlayContainer, { theme: theme }, children)));
};

const Container = styled.div `
  display: inline-block;
  cursor: pointer;
  box-sizing: border-box;
`;
const Tooltip = ({ children, className, gap, hideArrow, placement, overlay, trigger, visible, }) => {
    const [, forceRerender] = React.useState({});
    const [open, setOpen] = React.useState(false);
    const triggerRef = React.useRef(null);
    const handleMouseEnter = React.useCallback(() => {
        if (trigger !== undefined && trigger === 'hover') {
            setOpen(true);
        }
    }, [trigger]);
    const handleMouseLeave = React.useCallback(() => {
        setOpen(false);
    }, []);
    const handleOnClick = React.useCallback(() => {
        if (trigger !== undefined && trigger === 'click') {
            setOpen(true);
        }
    }, [trigger]);
    const isOpen = visible == null ? open && triggerRef !== null : visible;
    // If the initial visibility is set, force a rerender to cause the
    // ref anchorElement ref to be refetched by the floater
    // This is specifically useful for tests but also if user wants to control
    // the visibilty of a tooltip on their own
    React.useEffect(() => {
        if (visible == null) {
            return;
        }
        setTimeout(() => {
            forceRerender({});
        }, 0);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (React.createElement(Container, { ref: triggerRef, className: `${className} rtk-tooltip`, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, onClick: handleOnClick },
        children,
        React.createElement(Floater, { anchorElement: triggerRef.current, position: placements[placement], open: isOpen, style: { zIndex: 99999 } },
            React.createElement(TooltipContainer, { placement: placement, gap: gap, hideArrow: hideArrow }, overlay))));
};
Tooltip.defaultProps = {
    trigger: 'hover',
};
Tooltip.displayName = 'Tooltip';

export { Accordion, Badge, Button, Checkbox, Collapse, Divider, DropPad, Floater, FormItem, Icon, Input, Layout, Markdown, Menu, Modal, Notification, NotificationBin, NotificationBox, Panel, Portal, Radio, Select, Table, Tabs, Toggle, Tooltip, Typography, createTheme, getRelativePosition, useAfterMountEffect, useTheme, useUploadOnMountEffect };
